/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-use-before-define */
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Paper } from "@material-ui/core";

import {
  Table,
  InfoTable,
  ContractInvoiceView,
  Modal,
  Button,
  Labelbox,
  MultiDocumentPreviewDock,
  ClientBusinessManager,
  DocuSignSendModal,
  DocuSignSignaturePanel,
  FiledCopiesUploadFileList,
} from "../../components";
import useDocumentPreviewPanes from "../../hooks/useDocumentPreviewPanes";
import { useDocumentTabUnread } from "../../hooks/useDocumentTabUnread";
import { useBusinessDocumentScope } from "../../hooks/useBusinessDocumentScope";
import ClientBusinessSelector from "../../components/ClientBusinessSelector";
import {
  appendBusinessIdToFormData,
  recordMatchesBusinessScope,
} from "../../utils/businessDocumentContext";
import {
  appendFiledCopiesTagsToFormData,
  appendFiledCopiesServiceToFormData,
  emptyTagsForFileCount,
  requiresFiledCopiesDocumentTag,
  shouldShowFiledCopiesTagPicker,
  validateFiledCopiesUpload,
  markFiledCopiesServiceCompleted,
} from "../../utils/filedCopiesUpload";
import { buildClientServiceDropdownOptions } from "../../constants/clientServiceOptions";
import DocumentTabBadge from "../../components/DocumentTabBadge";
import {
  DOCUMENTS_HOME_NAV,
  isDocumentsHomePath,
  resolveActiveTabFromFolderType,
  resolveFolderTypeFromNav,
} from "../../utils/documentTabSwitch";
import {
  CLIENT_ACTION,
  INVOICE_ACTION,
  DOCUMENT_ACTION,
  CONTRACT_ACTION,
  MASTER_ACTION,
  EMPLOYEE_ACTION,
  MESSAGE_ACTION,
} from "../../redux/action";
import {
  dateFormatter,
  dateTimeFormatter,
  timeFormatter,
  NotificationContext,
  Toaster,
  Loader,
  encryptPassword,
  decryptPassword,
  getDocumentBlob,
  getRolePath,
  wait,
} from "../../utils/common";
import {
  isMaskedEmail,
  withUnmaskedBillToEmail,
} from "../../utils/clientEmailMasking";
import {
  openDocumentInNewTab,
  openDocumentPreviewTab,
} from "../../utils/openDocumentInNewTab";
import {
  getClientDocumentsActiveTab,
  getDocumentNotificationClientId,
  getDocumentNotificationRoute,
  getDocumentsFileTypeFromNotification,
  getMessageNotificationClientId,
  getMessageNotificationRoute,
  isDocumentOrFolderNotification,
  isMessageNotification,
  normalizeDocumentCategoryFromNotification,
} from "../../utils/notificationNavigation";
import { navigateToClientDetails } from "../../utils/clientDetailsSession";
import { clientHasBusinessAccess } from "../../utils/clientBusinessAccess";
import { canChangeClientEmailOrDeleteBusiness } from "../../utils/clientSensitiveEditAccess";
import {
  DOC_TYPE_K1_PACKAGE,
  DOC_TYPE_FILED_COPIES,
  getWantedDocTypeForPurposeTab,
  isInternalPurposeDocType,
  K1_PACKAGE_PURPOSE_TAB,
  FILED_COPIES_PURPOSE_TAB,
  K1_PACKAGE_TAB_LABEL,
  matchesPurposeTabFile,
  matchesPurposeTabFolder,
  resolveDocumentModalContextTab,
  resolveStaffDocTypeFromPurpose,
  getRootUploadFolderDropdownOptions,
} from "../../utils/moveDocumentScope";
import {
  searchDocumentRecursively,
  searchFolderRecursively,
} from "../../utils/documentNotificationSearch";
import { getClientById } from "../../redux/action/clientAction";
import {
  CLIENT_SELF_SUB_TABS,
  getStaffClientSubTabs,
  messageStoreKey,
  normalizeClientDetailCategory,
  recordMatchesClientCategory,
  filterRecordsByClientCategory,
  resolveTabsFromNavigationState,
} from "../../utils/clientDetailsCategory";
import { useClientCategoryTab } from "../../hooks/useClientCategoryTab";
import { useNotificationFeed } from "../../hooks/useNotificationFeed";
import {
  createDateFilterState,
  DEFAULT_DATE_RANGE_PRESET,
} from "../../utils/reportDateRanges";
import "./clientDetails.scss";
import {
  PrintRounded,
  GetAppRounded,
  Email,
  AttachMoney,
  Edit,
  Save as SaveIcon,
  Close as CloseIcon,
  Delete,
} from "@material-ui/icons";
import PhoneInput from "../../components/PhoneInput";
import { FileConverter, AddFolder, FileUpload } from "../../images";
import { useReactToPrint } from "react-to-print";
import PaymentStatusModal from "../../components/PaymentStatusModal";
import MoveItemModal from "../../components/MoveItemModal";
import {
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  TextField,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EmailNotificationSwitch from "../../components/EmailNotificationSwitch";
import {
  Visibility,
  GetApp,
  ExpandMore,
  DriveFileMoveOutlined,
} from "@mui/icons-material";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Empty from "antd/es/empty";
import "../documents/document.scss";
import { getReadableFileType, getFileTypeIcon } from "../../utils/common";
import RequestedFilesBlock from "../../components/requestedFilesBlock";
import UploadFilesHelpTooltip from "../../components/UploadFilesHelpTooltip";
import MessageChatInput from "../../components/MessageChatInput";
import MessageChatRow from "../../components/MessageChatRow";
import {
  DOCUMENT_UPLOAD_ACCEPT,
  DOCUMENT_UPLOAD_MAX_MB,
  DOCUMENT_UPLOAD_SIZE_NOTE,
  filterValidDocumentUploadFiles,
  hasInvalidDocumentUploadFiles,
} from "../../utils/documentUploadValidation";
import { fileBelongsToCurrentFolder } from "../../utils/documentFolderScope";
import {
  isSignableDocumentName,
  DOC_TAB_SENT_FOR_SIGNATURE,
  isDocumentsFolderTab,
} from "../../utils/docusignSignature";
import EfilingSection from "./EfilingSection";
import TaxStrategySection from "./TaxStrategySection";
import ClientServicesSection from "./ClientServicesSection";
import ContractPayment from "../contract_payment";
import {
  getInvoicePaymentStatusLabel,
  isInvoiceCancelled,
  formatInvoicePaidDateDisplay,
  shouldShowInvoicePaidDate,
} from "../../utils/invoiceStatusDisplay";

const formatDocumentCreatedAt = (item) =>
  dateTimeFormatter(item?.createdAt || item?.created_at);

const ClientDetails = () => {
  const [notificationLevel] = useState(50);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    categoryTab: clientCategoryTab,
    setCategoryTab: setClientCategoryTab,
    showCategoryChooser,
    syncBusinessAccess,
  } = useClientCategoryTab();
  const [staffCategoryTab, setStaffCategoryTab] = useState("individual");

  const userRole = (localStorage.getItem("user_role") || "").toLowerCase();
  const isClient = userRole === "client";
  const categoryTab = isClient ? clientCategoryTab : staffCategoryTab;
  const setCategoryTab = isClient ? setClientCategoryTab : setStaffCategoryTab;
  const docCategory = categoryTab;

  const [activeTab, setActiveTab] = useState(() =>
    localStorage.getItem("user_role") === "client" ? "messages" : "profile",
  );
  const [docFileType, setDocFileType] = useState("received");

  const isDocumentsTab = activeTab === "documents";
  const getActiveTabLabel = (tab) => {
    switch (tab) {
      case "received":
        return isClient ? "Files from FinloTax" : "Client Uploads";
      case "sent":
        return isClient ? "My Uploads" : "FinloTax Uploads";
      case "office":
        return "Internal Files";
      case "requested":
        return isClient ? "Pending Files" : "Documents Requested";
      case DOC_TAB_SENT_FOR_SIGNATURE:
        return isClient ? "Files for Signature" : "Sent for Signature";
      case FILED_COPIES_PURPOSE_TAB:
      case K1_PACKAGE_PURPOSE_TAB:
        return K1_PACKAGE_TAB_LABEL;
      default:
        return "Home";
    }
  };
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [deleteInvoiceDialog, setDeleteInvoiceDialog] = useState({
    open: false,
    invoice: null,
  });
  const [documentContent, setDocumentContent] = useState({
    state: false,
    data: {},
  });
  const componentRef = useRef();

  // Document management state
  const [navPath, setNavPath] = useState([
    { id: 0, name: "Home", created_by: 0 },
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const prevIndexRef = useRef(0);
  const documentNotificationSearchRef = useRef(false);
  const pendingDocTabSwitchRef = useRef(null);
  const documentOpenedFromNotificationRef = useRef(false);
  const [homeFolders, setHomeFolders] = useState([]);
  const [filetype, setFiletype] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const {
    previews: documentPreviews,
    addPreview: addDocumentPreview,
    removePreview: removeDocumentPreview,
    closeAllPreviews: closeAllDocumentPreviews,
    hasPreviews: hasDocumentPreviews,
  } = useDocumentPreviewPanes();
  const [newFolderName, setNewFolderName] = useState("");
  const [folderModalStage, setFolderModalStage] = useState("root");
  const [folderModalTitle, setFolderModalTitle] = useState("");
  const [folderModalReturnStage, setFolderModalReturnStage] = useState(null);
  const [folderModalContext, setFolderModalContext] = useState(null);
  const [folderModalPath, setFolderModalPath] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [filedCopiesFileTags, setFiledCopiesFileTags] = useState([]);
  const [filedCopiesServiceOptions, setFiledCopiesServiceOptions] = useState([]);
  const [filedCopiesSelectedServiceId, setFiledCopiesSelectedServiceId] =
    useState("");
  const [uploadSubFolderName, setUploadSubFolderName] = useState("");
  const [showUploadSubFolderInput, setShowUploadSubFolderInput] =
    useState(false);
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [renameFolderModalOpen, setRenameFolderModalOpen] = useState(false);
  const [moveModalOpen, setMoveModalOpen] = useState(false);
  const [moveItem, setMoveItem] = useState(null); // { type, data }
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [newName, setNewName] = useState("");
  const [sendNotifications, setSendNotifications] = useState(true);
  const [isDownloadedOpen, setIsDownloadedOpen] = useState(true);
  const [downloadedItems, setDownloadedItems] = useState([]);
  const [isDownloadedLoading, setIsDownloadedLoading] = useState(false);
  const [downloadedRefreshKey, setDownloadedRefreshKey] = useState(0);
  const [requestedFilesRefreshKey, setRequestedFilesRefreshKey] = useState(0);
  const [fileStructure, setFileStructure] = useState({
    folders: [],
    files: [],
  });
  const [pendingFolders, setPendingFolders] = useState([]);

  const resolveStaffDocType = resolveStaffDocTypeFromPurpose;

  const getDocumentModalContextTab = () =>
    resolveDocumentModalContextTab(docFileType, folderModalContext);

  const getFiledCopiesTagPickerContext = () => ({
    modalId: isModalOpen,
    isClient,
    purposeTab: docFileType,
    folderModalContext,
  });

  const showFiledCopiesTagPicker = shouldShowFiledCopiesTagPicker(
    getFiledCopiesTagPickerContext(),
  );

  const isBusinessDocCategory = docCategory === "business";

  const isK1PackageDocTab = docFileType === K1_PACKAGE_PURPOSE_TAB;
  const isIndividualFiledCopiesDocTab = docFileType === FILED_COPIES_PURPOSE_TAB;
  const isFiledCopiesDocTab = isK1PackageDocTab || isIndividualFiledCopiesDocTab;
  const currentDocTab = isFiledCopiesDocTab ? docFileType : docFileType;
  const handleDocFileTypeChange = (tab) => {
    if (tab === docFileType && isDocumentsHomePath(navPath)) {
      return;
    }
    navPath.slice(1).forEach((segment) => {
      if (segment?.id != null) {
        dismissFolderFileHighlights(segment.id, currentDocTab);
      }
    });
    pendingDocTabSwitchRef.current = tab;
    setNavPath(DOCUMENTS_HOME_NAV);
    setCurrentIndex(0);
    setFiletype("home");
    setDocFileType(tab);
  };

  const rootUploadFolderOptions = useMemo(
    () => getRootUploadFolderDropdownOptions(docCategory),
    [docCategory],
  );

  // Comments state
  const [commentText, setCommentText] = useState("");
  const [commentsList, setCommentsList] = useState([]);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const [isUpdatingComment, setIsUpdatingComment] = useState(false);
  const [editCommentModal, setEditCommentModal] = useState({
    open: false,
    commentId: null,
    text: "",
  });
  const [commentDateFilter, setCommentDateFilter] = useState(() =>
    createDateFilterState(),
  );

  // Messages state (client <-> associate)
  const [messageText, setMessageText] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [showClientPaymentDetails, setShowClientPaymentDetails] =
    useState(false);
  const messagesListRef = useRef(null);
  const [signatureModal, setSignatureModal] = useState({
    open: false,
    document: null,
  });
  const [signatureRefreshKey, setSignatureRefreshKey] = useState(0);

  // Personal details edit state
  const [isPersonalEditMode, setIsPersonalEditMode] = useState(false);
  const [personalEditedData, setPersonalEditedData] = useState({});
  const [isSavingPersonal, setIsSavingPersonal] = useState(false);

  // Business details edit state
  const [isBusinessEditMode, setIsBusinessEditMode] = useState(false);
  const [businessEditedData, setBusinessEditedData] = useState({});
  const [isSavingBusiness, setIsSavingBusiness] = useState(false);

  // Client/Employee flags
  const isEmployee = !isClient;
  const isAdmin = userRole === "admin";
  const isManager = userRole === "manager";
  const loggedInUserId = localStorage.getItem("user_id");
  const canEditClient = isAdmin || isManager;
  const canChangeClientEmail = canChangeClientEmailOrDeleteBusiness();
  const canDeleteClientBusiness = canChangeClientEmail;
  const canManageClientBusinesses =
    isClient || isAdmin || isManager || userRole === "employee";
  /** Received tab: only admin may delete client documents. */
  const canDeleteDocument =
    !isClient && (docFileType !== "received" || isAdmin);

  const formatTime = (ts) => {
    if (!ts) return "";
    try {
      return timeFormatter(ts).toLowerCase();
    } catch (e) {
      return "";
    }
  };

  const formatMessageDate = (ts) => {
    if (!ts) return "";
    try {
      return dateFormatter(ts);
    } catch (e) {
      return "";
    }
  };

  const cancelEditMessage = useCallback(() => {
    setEditingMessageId(null);
    setMessageText("");
  }, []);

  const startEditMessage = useCallback((message) => {
    setEditingMessageId(message?.message_id ?? null);
    setMessageText(message?.message ?? "");
  }, []);

  const sendOrSaveMessage = useCallback(async () => {
    const text = messageText.trim();
    if (!text || !id) return;
    setIsSendingMessage(true);
    try {
      if (editingMessageId) {
        await dispatch(
          MESSAGE_ACTION.updateClientMessage({
            messageId: editingMessageId,
            clientId: id,
            text,
          }),
        ).unwrap();
        cancelEditMessage();
        Toaster.success("Message updated.");
      } else {
        await dispatch(
          MESSAGE_ACTION.sendClientMessage({
            clientId: id,
            text,
            category: categoryTab,
          }),
        ).unwrap();
        setMessageText("");
      }
      dispatch(
        MESSAGE_ACTION.getClientMessages({ clientId: id, category: categoryTab }),
      );
    } catch (err) {
      Toaster.error(
        editingMessageId
          ? "Failed to update message"
          : "Failed to send message",
      );
    } finally {
      setIsSendingMessage(false);
    }
  }, [messageText, id, editingMessageId, dispatch, cancelEditMessage, categoryTab]);

  const { allClients } = useSelector((state) => state.client);
  const { allInvoices } = useSelector((state) => state.invoice || {});
  const { userFiles, userFolders, allClientDocuments } = useSelector(
    (state) => state.document || {},
  );

  const folderExists = useMemo(() => {
    if (!newFolderName) return false;
    const name = newFolderName.trim().toLowerCase();
    return (userFolders || []).some(
      (f) =>
        f.folder_name?.trim().toLowerCase() === name &&
        matchesPurposeTabFolder(f, docFileType),
    );
  }, [newFolderName, userFolders, docFileType]);
  const { activeEmployees } = useSelector((state) => state.employee || {});
  const { master } = useSelector((state) => state);
  const { messagesByClientId } = useSelector((state) => state.message || {});
  const { notifications } = useContext(NotificationContext) || {
    notifications: [],
  };
  const { refresh: refreshNotifications, markReadLocal } = useNotificationFeed();

  // Get client data from location state or allClients
  const [fetchedClient, setFetchedClient] = useState(null);

  const clientData = useMemo(() => {
    if (fetchedClient) {
      return fetchedClient;
    }
    if (location.state?.data) {
      return location.state.data;
    }
    if (allClients && allClients.length > 0) {
      return (
        allClients.find((client) => String(client.client_id) === String(id)) ||
        null
      );
    }
    if (
      isClient &&
      loggedInUserId &&
      String(id) === String(loggedInUserId)
    ) {
      try {
        const userData = JSON.parse(localStorage.getItem("USER_DATA") || "{}");
        if (Object.keys(userData).length) {
          return {
            ...userData,
            client_id: userData.client_id || loggedInUserId,
          };
        }
      } catch (_) {
        /* ignore */
      }
    }
    return null;
  }, [location.state, allClients, id, fetchedClient, isClient, loggedInUserId]);

  const navigationClient =
    location.state?.data &&
    String(location.state.data.client_id) === String(id)
      ? location.state.data
      : null;
  const accountClientType =
    clientData?.client_type || navigationClient?.client_type;
  const isBusinessClient =
    String(accountClientType || "")
      .trim()
      .toLowerCase()
      .startsWith("business") && clientHasBusinessAccess(clientData);

  const {
    businesses: clientBusinesses,
    selectedClientBusinessId,
    setSelectedClientBusinessId,
    clientS3Root,
    documentHomeFolder,
    appendDocScope,
    showBusinessSelector,
    refreshBusinesses,
  } = useBusinessDocumentScope({
    clientId: id,
    clientRecord: clientData,
    documentCategory: docCategory,
  });

  useEffect(() => {
    if (isDocumentsTab && isBusinessDocCategory && id) {
      refreshBusinesses();
    }
  }, [isDocumentsTab, isBusinessDocCategory, id, refreshBusinesses]);

  const {
    counts: documentTabUnread,
    getFolderUnreadCount,
    isFileHighlighted,
    clearFolderUnread,
    dismissFileHighlight,
    dismissFolderFileHighlights,
  } = useDocumentTabUnread({
    clientId: id,
    documentCategory: docCategory,
    clientBusinessId: isBusinessDocCategory ? selectedClientBusinessId : null,
    fileStructure,
  });

  const showClientDetailsCategoryTabs = isClient
    ? showCategoryChooser
    : isBusinessClient;

  const staffSubTabs = useMemo(
    () => getStaffClientSubTabs(categoryTab),
    [categoryTab],
  );

  // Always fetch fresh client data for personal details (and fall back to list)
  useEffect(() => {
    if (isClient) {
      if (String(id) !== String(loggedInUserId)) {
        navigate(getRolePath("/dashboard"));
        return;
      }
      dispatch(getClientById(id))
        .unwrap()
        .then((data) => {
          if (data) {
            setFetchedClient(data);
            if (isClient) syncBusinessAccess(data);
          }
        })
        .catch(() => {});
      return;
    }
    if (id) {
      if (!clientData) {
        dispatch(CLIENT_ACTION.getAllClients());
      }
      dispatch(getClientById(id))
        .unwrap()
        .then((data) => {
          if (data) setFetchedClient(data);
        })
        .catch(() => {});
    }
  }, [dispatch, id, isClient, loggedInUserId, navigate, syncBusinessAccess]);

  // Allow navigation to open a specific tab (e.g. from Dashboard / notifications)
  useEffect(() => {
    const tab = location?.state?.tab;
    const documentsTab = location?.state?.documentsTab;
    const { categoryTab: nextCategory, activeTab: nextTab } =
      resolveTabsFromNavigationState(location?.state || {});

    if (tab === "signature") {
      // Signature tab temporarily hidden — open Documents instead
      setActiveTab("documents");
      setDocFileType("sent");
    } else if (tab || location?.state?.documentCategory) {
      setCategoryTab(nextCategory);
      setActiveTab(nextTab);
    } else if (isClient) {
      setActiveTab("messages");
    }

    if (
      documentsTab === "sent" ||
      documentsTab === "received" ||
      documentsTab === "office" ||
      documentsTab === DOC_TAB_SENT_FOR_SIGNATURE ||
      documentsTab === K1_PACKAGE_PURPOSE_TAB ||
      documentsTab === FILED_COPIES_PURPOSE_TAB
    ) {
      setDocFileType(documentsTab);
    }
  }, [location?.state, isClient]);

  // Fetch invoices for this client
  useEffect(() => {
    if (id && (activeTab === "invoices" || activeTab === "e-filing")) {
      dispatch(
        INVOICE_ACTION.getAllInvoices({
          billed_to: id,
          category: categoryTab,
        }),
      );
    }
  }, [dispatch, id, activeTab, categoryTab]);

  // Fetch comments for this client
  useEffect(() => {
    if (!id || activeTab !== "comments") return;
    setCommentsList([]);
    dispatch(
      CLIENT_ACTION.getClientComments({
        clientId: id,
        start_date: commentDateFilter.start_date,
        end_date: commentDateFilter.end_date,
        category: categoryTab,
      }),
    )
      .unwrap()
      .then((data) => {
        setCommentsList(data || []);
      })
      .catch(() => {
        setCommentsList([]);
      });
  }, [
    dispatch,
    id,
    activeTab,
    categoryTab,
    commentDateFilter.start_date,
    commentDateFilter.end_date,
  ]);

  const commentDateRanges = useMemo(
    () => [
      "All",
      "Today",
      "This Week",
      "Last Week",
      "This Month",
      "Last Month",
      "This Quarter",
      "Last Quarter",
      "This Year",
      "Last Year",
      "Custom",
    ],
    [],
  );

  const getDateRange = useCallback((filter) => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    if (!filter || filter === "All")
      return { start_date: null, end_date: null };

    const today = new Date();
    let startDate;
    let endDate = new Date(today);

    switch (filter) {
      case "Today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case "This Week":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay());
        break;
      case "Last Week":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay() - 7);
        endDate = new Date(today);
        endDate.setDate(today.getDate() - today.getDay() - 1);
        break;
      case "This Month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "Last Month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "This Quarter": {
        const thisQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
        startDate = new Date(today.getFullYear(), thisQuarterStartMonth, 1);
        endDate = new Date(today.getFullYear(), thisQuarterStartMonth + 3, 0);
        break;
      }
      case "Last Quarter": {
        let lastQuarterStartMonth = Math.floor(today.getMonth() / 3) * 3 - 3;
        let lastQuarterYear = today.getFullYear();
        if (lastQuarterStartMonth < 0) {
          lastQuarterStartMonth += 12;
          lastQuarterYear -= 1;
        }
        startDate = new Date(lastQuarterYear, lastQuarterStartMonth, 1);
        endDate = new Date(lastQuarterYear, lastQuarterStartMonth + 3, 0);
        break;
      }
      case "This Year":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today.getFullYear(), 11, 31);
        break;
      case "Last Year":
        startDate = new Date(today.getFullYear() - 1, 0, 1);
        endDate = new Date(today.getFullYear() - 1, 11, 31);
        break;
      default:
        return { start_date: null, end_date: null };
    }

    return { start_date: formatDate(startDate), end_date: formatDate(endDate) };
  }, []);

  const filteredCommentsList = useMemo(() => {
    const byCategory = (commentsList || []).filter((c) =>
      recordMatchesClientCategory(c, categoryTab),
    );
    const { start_date, end_date } = commentDateFilter || {};
    if (!start_date && !end_date) return byCategory;

    const start = start_date ? new Date(`${start_date}T00:00:00`) : null;
    const end = end_date ? new Date(`${end_date}T23:59:59.999`) : null;

    return byCategory.filter((c) => {
      const raw = c?.createdAt || c?.date || c?.created_at;
      if (!raw) return true;
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return true;
      if (start && d < start) return false;
      if (end && d > end) return false;
      return true;
    });
  }, [commentsList, commentDateFilter, categoryTab]);

  // Fetch messages for this client
  const clientMessages = useMemo(() => {
    if (!id) return [];
    return messagesByClientId?.[messageStoreKey(id, categoryTab)] || [];
  }, [messagesByClientId, id, categoryTab]);

  const displayMessages = useMemo(
    () =>
      (clientMessages || []).filter((m) =>
        recordMatchesClientCategory(m, categoryTab),
      ),
    [clientMessages, categoryTab],
  );

  useEffect(() => {
    if (id && activeTab === "messages") {
      dispatch(
        MESSAGE_ACTION.getClientMessages({ clientId: id, category: categoryTab }),
      );
      dispatch(
        MESSAGE_ACTION.markClientThreadRead({
          clientId: id,
          category: categoryTab,
        }),
      );
    }
  }, [dispatch, id, activeTab, categoryTab]);

  useEffect(() => {
    if (activeTab !== "messages") return;
    const listEl = messagesListRef.current;
    if (!listEl) return;
    listEl.scrollTop = listEl.scrollHeight;
  }, [activeTab, displayMessages]);

  useEffect(() => {
    const mainEl = document.querySelector(".main-area main");
    if (!mainEl) return undefined;
    if (activeTab === "messages") {
      mainEl.classList.add("main--client-messages");
    } else {
      mainEl.classList.remove("main--client-messages");
    }
    return () => mainEl.classList.remove("main--client-messages");
  }, [activeTab]);

  useEffect(() => {
    setCommentText("");
    cancelEditMessage();
  }, [categoryTab, cancelEditMessage]);

  // Fetch active employees for employee name lookup
  useEffect(() => {
    dispatch(EMPLOYEE_ACTION.getActiveEmployees());
  }, [dispatch]);

  // Fetch master data for business details
  useEffect(() => {
    dispatch(MASTER_ACTION.getMasterData({ name: "country" }));
  }, [dispatch]);

  // Fetch states when country_id is available (for personal details)
  useEffect(() => {
    if (clientData?.country_id) {
      dispatch(
        MASTER_ACTION.getMasterData({
          name: "state",
          id: clientData.country_id,
        }),
      );
    }
  }, [dispatch, clientData?.country_id]);

  // Fetch states when business_country_id is available
  useEffect(() => {
    if (clientData?.business_country_id) {
      dispatch(
        MASTER_ACTION.getMasterData({
          name: "state",
          name_type: "business_state",
          id: clientData.business_country_id,
        }),
      );
    }
  }, [dispatch, clientData?.business_country_id]);

  // Get HOME_FOLDER and HOME_USER_ID for documents
  const HOME_USER_ID = id; // Client ID from params
  /** Client S3 root — used as folder_name in list APIs at Home (single URL segment). */
  const CLIENT_S3_ROOT = useMemo(
    () =>
      clientData?.s3_root_folder || clientData?.home_folder || "Home",
    [clientData],
  );
  /** Full prefix for uploads / directory_details (includes /Business/{id} when applicable). */
  const DOCUMENT_HOME_FOLDER = isBusinessDocCategory
    ? documentHomeFolder
    : CLIENT_S3_ROOT;
  const HOME_FOLDER = DOCUMENT_HOME_FOLDER;

  // Helper functions for document navigation
  const getPath = () => {
    const lastPath = navPath[navPath.length - 1];
    if (lastPath.name === "Home") {
      return { id: 0, name: CLIENT_S3_ROOT, created_by: 0 };
    }
    return lastPath;
  };

  const getKeyPath = () => {
    let keyPathArr = [...navPath];
    keyPathArr.splice(0, 1, { id: 0, name: DOCUMENT_HOME_FOLDER });
    const keyPath = keyPathArr.map((u) => u.name).join("/");
    return keyPath;
  };

  // Reset navPath when switching documents tab or document category
  useEffect(() => {
    if (isDocumentsTab) {
      setNavPath(DOCUMENTS_HOME_NAV);
      setCurrentIndex(0);
    }
  }, [isDocumentsTab, docCategory]);

  useEffect(() => {
    if (!isDocumentsTab || !isBusinessDocCategory) return;
    setNavPath(DOCUMENTS_HOME_NAV);
    setCurrentIndex(0);
    setFiletype("home");
  }, [selectedClientBusinessId, isDocumentsTab, isBusinessDocCategory]);

  useEffect(() => {
    if (!isBusinessClient && categoryTab === "business") {
      setCategoryTab("individual");
    }
  }, [isBusinessClient, categoryTab]);

  useEffect(() => {
    if (!isBusinessDocCategory && docFileType === K1_PACKAGE_PURPOSE_TAB) {
      setDocFileType("received");
    }
    if (isBusinessDocCategory && docFileType === FILED_COPIES_PURPOSE_TAB) {
      setDocFileType("received");
    }
  }, [isBusinessDocCategory, docFileType]);

  // Fetch documents for this client based on navigation path
  useEffect(() => {
    if (!isDocumentsFolderTab(docFileType)) return;
    if (id && isDocumentsTab && clientData && CLIENT_S3_ROOT) {
      let path = getPath();

      // Fetch folders (scoped to current document_category + business)
      dispatch(
        DOCUMENT_ACTION.getUserFolders(
          appendDocScope({
            user_id: id,
            folder_name: path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );

      // Fetch files (scoped to current document_category + business)
      dispatch(
        DOCUMENT_ACTION.getUserFiles(
          appendDocScope({
            user_id: id,
            folder_name: path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );
    }
  }, [
    dispatch,
    id,
    isDocumentsTab,
    docCategory,
    clientData,
    CLIENT_S3_ROOT,
    documentHomeFolder,
    navPath,
    docFileType,
    selectedClientBusinessId,
    appendDocScope,
  ]);

  // Update file structure when files/folders change
  useEffect(() => {
    if (HOME_USER_ID) {
      const scopedFiles = filterRecordsByClientCategory(
        (userFiles || [])
          .filter((file) => fileBelongsToCurrentFolder(file, navPath))
          .filter((file) =>
            recordMatchesBusinessScope(file, selectedClientBusinessId),
          ),
        docCategory,
      );
      const scopedFolders = filterRecordsByClientCategory(
        (userFolders || []).filter((folder) =>
          recordMatchesBusinessScope(folder, selectedClientBusinessId),
        ),
        docCategory,
      );
      setFileStructure((prev) => ({
        ...prev,
        files: scopedFiles,
        folders: scopedFolders,
      }));
    }
  }, [userFiles, userFolders, HOME_USER_ID, navPath, docCategory, selectedClientBusinessId]);

  // Store folders from Redux
  useEffect(() => {
    setHomeFolders(filterRecordsByClientCategory(userFolders || [], docCategory));
  }, [userFolders, docCategory]);

  // Resolve folder type from navigation (Home => "home").
  useEffect(() => {
    if (navPath.length > 0) {
      setFiletype(resolveFolderTypeFromNav(navPath, homeFolders, HOME_FOLDER));
    }
  }, [navPath, homeFolders, HOME_FOLDER]);

  useEffect(() => {
    if (!isDocumentsTab) return;
    setFileStructure({ folders: [], files: [] });
    setHomeFolders([]);
  }, [docCategory, isDocumentsTab]);

  // Clear pending manual tab switch once home + target tab are applied.
  useEffect(() => {
    const pending = pendingDocTabSwitchRef.current;
    if (!pending) return;
    if (docFileType === pending && isDocumentsHomePath(navPath)) {
      pendingDocTabSwitchRef.current = null;
    }
  }, [docFileType, navPath]);

  // Auto-select tab when user opens a folder (not during manual tab switches).
  useEffect(() => {
    if (pendingDocTabSwitchRef.current) return;
    if (!isDocumentsTab) return;
    if (!isDocumentsFolderTab(docFileType)) return;

    const current = navPath[navPath.length - 1];
    if (!current || Number(current.id) === 0) return;

    const folderType =
      current.folder_type ||
      filetype ||
      resolveFolderTypeFromNav(navPath, homeFolders, HOME_FOLDER);
    const nextTab = resolveActiveTabFromFolderType(folderType, {
      isClient,
      docCategory,
      autoSwitchSentReceived: true,
    });
    if (nextTab && nextTab !== docFileType) {
      setDocFileType(nextTab);
    }
  }, [
    navPath,
    filetype,
    isClient,
    isDocumentsTab,
    docCategory,
    docFileType,
    homeFolders,
    HOME_FOLDER,
  ]);

  // Refresh notifications when the notification tab becomes active.
  useEffect(() => {
    if (activeTab !== "notification") return;
    refreshNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // Filter invoices for this client
  const clientInvoices = useMemo(() => {
    if (!allInvoices || !id) return [];
    return allInvoices.filter(
      (invoice) =>
        String(invoice.billed_to) === String(id) &&
        recordMatchesClientCategory(invoice, categoryTab),
    );
  }, [allInvoices, id, categoryTab]);

  const ensureClientInvoicesForEfiling = useCallback(() => {
    if (id) {
      dispatch(
        INVOICE_ACTION.getAllInvoices({
          billed_to: id,
          category: categoryTab,
        }),
      );
    }
  }, [dispatch, id, categoryTab]);

  // Filter notifications for this client
  const clientNotifications = useMemo(() => {
    if (!notifications || !id || !clientData) return [];
    const clientName = `${clientData.first_name} ${clientData.last_name}`;
    return notifications.filter((notif) => {
      const message = (notif.message || "").toLowerCase();
      const nameLower = clientName.toLowerCase();
      const emailLower = (clientData.email || "").toLowerCase();
      return (
        message.includes(nameLower) ||
        message.includes(emailLower) ||
        (notif.client_id && String(notif.client_id) === String(id))
      );
    });
  }, [notifications, id, clientData]);

  // Invoice table data with payment status colors
  const invoiceTableData = useMemo(() => {
    const InvoiceStatus = {
      0: "Pending",
      1: "Paid",
      2: "Partially Paid",
      3: "Closed",
      4: "Cancelled",
      null: "Pending",
    };

    const getComputedPaymentStatus = (invoice) =>
      getInvoicePaymentStatusLabel(invoice);

    return clientInvoices.map((invoice) => {
      const {
        invoice_no,
        invoice_date,
        bill_from_first_name,
        bill_from_last_name,
        bill_to_first_name,
        bill_to_last_name,
        total,
        updatedAt,
      } = invoice;

      const totalNum = parseFloat(total || 0);
      const paymentStatusLabel = getComputedPaymentStatus(invoice);
      const canPay = ["Pending", "Partially Paid"].includes(paymentStatusLabel);
      const isCancelled = isInvoiceCancelled(invoice);

      // Determine payment status (match create_contract_invoice logic)
      let paymentStatus = "unpaid";
      if (paymentStatusLabel === "Paid") {
        paymentStatus = "paid";
      } else if (paymentStatusLabel === "Partially Paid") {
        paymentStatus = "partial";
      } else if (isCancelled) {
        paymentStatus = "cancelled";
      }

      // Determine background color for inline style fallback
      let rowBgColor = "#fff";
      if (paymentStatus === "unpaid") {
        rowBgColor = "#B44B4B"; // light red
      } else if (paymentStatus === "partial") {
        rowBgColor = "#B44B4B"; // light orange
      } else if (paymentStatus === "paid") {
        rowBgColor = "#3B9B3E"; // light green
      } else if (paymentStatus === "cancelled") {
        rowBgColor = "#fef3f2";
      }

      return {
        invoice_no,
        invoice_date: dateFormatter(invoice_date),
        billed_by: `${bill_from_first_name || ""} ${
          bill_from_last_name || ""
        }`.trim(),
        billed_to: `${bill_to_first_name || ""} ${
          bill_to_last_name || ""
        }`.trim(),
        net_total: `$ ${totalNum.toFixed(2)}`,
        payment_status: paymentStatusLabel,
        paid_date: shouldShowInvoicePaidDate(invoice)
          ? formatInvoicePaidDateDisplay(invoice)
          : "—",
        last_updated: dateFormatter(updatedAt),
        _rowClass: `invoice-row-${paymentStatus}`,
        _rowStyle: { backgroundColor: rowBgColor },
        _invoiceData: invoice,
        enabledActions: {
          print: true,
          email: true,
          paymentStatus: true,
          edit: !isCancelled,
          delete: true,
          pay: canPay,
        },
      };
    });
  }, [clientInvoices]);

  // Invoice table header
  const invoiceHeader = [
    { id: "icon", label: "" },
    { id: "invoice_no", label: "Invoice No." },
    { id: "invoice_date", label: "Invoice Date" },
    { id: "billed_by", label: "Billed By" },
    { id: "billed_to", label: "Billed To" },
    { id: "net_total", label: "Net Total" },
    { id: "payment_status", label: "Payment Status" },
    { id: "paid_date", label: "Paid Date" },
    { id: "last_updated", label: "Last Updated" },
    { id: "action", label: "Action" },
  ];

  const getFileNameWithoutExtension = (filename = "") => {
    const lastDot = filename.lastIndexOf(".");
    if (lastDot === -1) return filename;
    return filename.substring(0, lastDot);
  };

  const getFileExtension = (filename = "") => {
    const lastDot = filename.lastIndexOf(".");
    if (lastDot === -1) return "";
    return filename.substring(lastDot); // includes dot
  };

  const normalizeMimeType = (item) => {
    if (item.document_type) return item.document_type;

    let ext = (item.document_extension || "").toLowerCase();

    if (!ext && item.document_name?.includes(".")) {
      ext = item.document_name.split(".").pop().toLowerCase();
    }

    if (!ext && item.document_link?.includes(".")) {
      ext = item.document_link.split(".").pop().split("?")[0].toLowerCase();
    }

    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext)) {
      return `image/${ext === "svg" ? "svg+xml" : ext}`;
    }

    if (ext === "pdf") return "application/pdf";
    if (["doc", "docx"].includes(ext)) return "application/msword";
    if (["xls", "xlsx"].includes(ext)) return "application/vnd.ms-excel";

    return "";
  };

  const currentDocType = () => resolveStaffDocTypeFromPurpose(docFileType);

  // Documents table data
  const documentTableData = useMemo(() => {
    const files = userFiles || [];
    const folders = userFolders || [];

    const filteredFolders = folders.filter((folder) =>
      matchesPurposeTabFolder(folder, docFileType),
    );

    const filteredFiles = files.filter((file) => {
      if (!fileBelongsToCurrentFolder(file, navPath)) return false;
      return matchesPurposeTabFile(file, docFileType);
    });

    // Combine folders and files
    const allItems = [
      ...filteredFolders.map((folder) => ({ ...folder, type: "folder" })),
      ...filteredFiles.map((file) => ({ ...file, type: "file" })),
    ];

    return allItems.map((item) => ({
      document: (
        <div className="doc-name-cell">
          <span className="doc-icon">
            {getFileTypeIcon(
              item.type === "folder" ? null : normalizeMimeType(item),
              item.type === "folder",
            )}
          </span>
          <span>{item.folder_name || item.document_name}</span>
        </div>
      ),
      date: dateTimeFormatter(item.createdAt || item.updatedAt),
      file_type: getReadableFileType(
        normalizeMimeType(item),
        item.type === "folder",
      ),
    }));
  }, [userFiles, userFolders, docFileType, navPath]);

  // Documents table header
  const documentHeader = [
    { id: "document", label: "Document" },
    { id: "date", label: "Date" },
    // { id: "date_2", label: "Date" }, // Two date columns as per image
    { id: "file_type", label: "File Type" },
    { id: "action", label: "Action" },
  ];

  // Notification table data
  const notificationTableData = useMemo(() => {
    return clientNotifications.map((notif) => {
      const dateStr = dateTimeFormatter(notif.createdAt);
      const timeStr = notif.createdAt ? timeFormatter(notif.createdAt) : "";

      const isViewed =
        notif.view_status === "Viewed" || notif.view_status === "viewed";

      // Determine background color: white for viewed, grayish for unviewed
      const rowBgColor = isViewed ? "#ffffff" : "#F2F2F2"; // white for viewed, light gray for unviewed

      return {
        info: notif.message || "---",
        date: dateStr,
        viewed: isViewed,
        _rowClass: isViewed
          ? "notification-row-viewed"
          : "notification-row-unviewed",
        _rowStyle: { backgroundColor: rowBgColor },
        _notificationData: notif,
      };
    });
  }, [clientNotifications]);

  // Notification table header
  const notificationHeader = [
    { id: "info", label: "Info" },
    { id: "date", label: "Date" },
  ];

  // Handle payment status modal
  const handlePaymentStatusOpen = (invoice) => {
    setSelectedInvoice(invoice);
    setPaymentStatusModal(true);
  };

  const handlePaymentStatusClose = async () => {
    setPaymentStatusModal(false);
    setSelectedInvoice(null);
    // Refresh invoices after update - wait a bit for the API to complete
    if (id) {
      setTimeout(() => {
        dispatch(
          INVOICE_ACTION.getAllInvoices({
            billed_to: id,
            category: categoryTab,
          }),
        );
      }, 500);
    }
  };

  const openDeleteInvoiceDialog = (invoice) => {
    setDeleteInvoiceDialog({ open: true, invoice });
  };

  const closeDeleteInvoiceDialog = () => {
    setDeleteInvoiceDialog({ open: false, invoice: null });
  };

  const confirmDeleteInvoice = async () => {
    if (!deleteInvoiceDialog.invoice) return;
    try {
      const response = await INVOICE_ACTION.deleteInvoiceById(
        deleteInvoiceDialog.invoice.client_invoice_id,
      );
      if (response.status === 200 && response?.data?.status !== 0) {
        Toaster.success("Invoice is successfully deleted.");
        dispatch(
          INVOICE_ACTION.getAllInvoices({
            billed_to: id,
            category: categoryTab,
          }),
        );
      } else {
        Toaster.error("Error Deleting the Invoice.");
      }
    } catch (error) {
      Toaster.error(`Error occurred: ${error.message}`);
    } finally {
      closeDeleteInvoiceDialog();
    }
  };

  // Print handler
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // Email handler
  const handleSendMail = async (invoiceData) => {
    Loader(true);
    try {
      if (invoiceData && typeof invoiceData === "object") {
        setDocumentContent((prev) => ({
          ...prev,
          data: invoiceData,
        }));
        await wait(250);
        await new Promise((resolve) =>
          window.requestAnimationFrame(() =>
            window.requestAnimationFrame(resolve),
          ),
        );
      }

      if (!document.getElementById("divToPrint")) {
        throw new Error("Invoice document is not ready for email.");
      }

      let formData = new FormData();
      formData.append("file", await getDocumentBlob());

      const response = await CONTRACT_ACTION.sendEmail({
        binaryData: formData,
        create: false,
        origin: "Invoice",
        id: invoiceData.client_invoice_id,
      });

      Loader(false);
      if (response.status === 200 && response.data.status === 1) {
        Toaster.success("Attachment has been successfully sent to the client");
      } else if (response.status === 200 && response.data.status === 0) {
        Toaster.warning(response.data.message);
      } else {
        Toaster.error("Error occurred while sending the attachment");
      }
    } catch (error) {
      Loader(false);
      Toaster.error("Error occurred while sending the attachment");
    }
  };

  function handleCreateInvoice() {
    const normalizedClientData = {
      ...clientData,
      country: getCountryName(clientData?.country_id),
      state: getStateName(clientData?.state_id),
      business_country: getCountryName(clientData?.business_country_id),
      business_state: getStateName(clientData?.business_state_id, true),
    };

    navigate(getRolePath("/invoice_contract"), {
      state: {
        client_id: id,
        mode: "invoice",
        data: normalizedClientData,
        fromClientDetails: true,
        lockBilledParties: true,
        category: categoryTab,
      },
    });
  }

  const loadInvoiceDocumentData = async (invoice) => {
    const invoiceId = invoice?.client_invoice_id;
    let detail = invoice;
    if (invoiceId) {
      try {
        const response = await INVOICE_ACTION.getInvoiceDetail(invoiceId);
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.data
        ) {
          const fetched = response.data.data;
          detail = {
            ...fetched,
            status: fetched.status ?? invoice.status,
            _invoiceData: invoice,
          };
        }
      } catch (err) {
        console.error("Error fetching invoice details:", err);
        detail = { ...invoice, _invoiceData: invoice };
      }
    } else {
      detail = { ...invoice, _invoiceData: invoice };
    }

    try {
      const unmasked = await withUnmaskedBillToEmail(
        detail,
        async (clientId) => {
          try {
            return await dispatch(
              CLIENT_ACTION.getClientById(clientId),
            ).unwrap();
          } catch {
            // Prefer full email already on client details page.
            if (
              clientData?.email &&
              !isMaskedEmail(clientData.email) &&
              String(clientData.client_id ?? id) === String(clientId)
            ) {
              return clientData;
            }
            return null;
          }
        },
      );
      // Client details page often already has the full email.
      if (
        isMaskedEmail(unmasked?.bill_to_email) &&
        clientData?.email &&
        !isMaskedEmail(clientData.email)
      ) {
        return {
          ...unmasked,
          bill_to_email: clientData.email,
        };
      }
      return unmasked;
    } catch {
      if (clientData?.email && !isMaskedEmail(clientData.email)) {
        return { ...detail, bill_to_email: clientData.email };
      }
      return detail;
    }
  };

  // Handle invoice actions
  const handleInvoiceAction = async (type, actionData, actionIndex) => {
    const invoice = actionData._invoiceData;

    if (type === "paymentStatus") {
      handlePaymentStatusOpen(invoice);
      return;
    } else if (type === "eye") {
      const detail = await loadInvoiceDocumentData(invoice);
      setDocumentContent({
        state: true,
        data: detail,
      });
      return;
    } else if (type === "print") {
      const detail = await loadInvoiceDocumentData(invoice);
      setDocumentContent({
        state: false,
        data: detail,
      });
      await wait(200);
      await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve)),
      );
      handlePrint();
      return;
    } else if (type === "email") {
      const detail = await loadInvoiceDocumentData(invoice);
      setDocumentContent({
        state: false,
        data: detail,
      });
      await wait(200);
      await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve)),
      );
      await handleSendMail(detail);
      return;
    } else if (type === "edit") {
      if (isInvoiceCancelled(invoice)) {
        Toaster.warning("Cancelled invoices cannot be edited.");
        return;
      }
      navigate(getRolePath("/invoice_contract"), {
        state: {
          client_id: id,
          mode: "invoice",
          data: invoice,
          fromClientDetails: true,
          lockBilledParties: true,
        },
      });
      return;
    } else if (type === "delete") {
      openDeleteInvoiceDialog(invoice);
      return;
    } else if (type === "pay") {
      setShowClientPaymentDetails(true);
      return;
    }
  };

  // Handle notification click - same as notification page
  const handleNotificationClick = async (notification) => {
    if (
      !notification ||
      !notification.notification_type ||
      !notification.notification_item_id
    ) {
      return;
    }

    try {
      // Update notification status (mark as viewed)
      await MASTER_ACTION.updateNotification(notification.notification_id);
      markReadLocal(notification.notification_id);

      const USER_TYPE = localStorage.getItem("user_role");

      // Define action routes based on notification type
      const ACTION = {
        folder: [DOCUMENT_ACTION.getFolderDetails, "/finlo/documents"],
        document: [DOCUMENT_ACTION.getDocumentDetails, "/finlo/documents"],
        invoice: [
          INVOICE_ACTION.getInvoiceDetail,
          USER_TYPE === "client" ? "/finlo/payment" : "/finlo/invoice_contract",
        ],
        contract: [
          CONTRACT_ACTION.getContractDetail,
          USER_TYPE === "client"
            ? "/finlo/contract_proposal"
            : "/finlo/invoice_contract",
        ],
      };

      const { notification_type, notification_item_id } = notification;

      if (isDocumentOrFolderNotification(notification)) {
        let enriched = notification;
        if (
          !notification.document_category &&
          !notification.documentCategory &&
          notification_item_id
        ) {
          try {
            const detailRes =
              notification_type === "document"
                ? await DOCUMENT_ACTION.getDocumentDetails(notification_item_id)
                : await DOCUMENT_ACTION.getFolderDetails(notification_item_id);
            if (detailRes?.status === 200 && detailRes?.data?.data) {
              enriched = {
                ...notification,
                document_category:
                  detailRes.data.data.document_category ||
                  detailRes.data.data.folder_category ||
                  detailRes.data.data.category,
              };
            }
          } catch {
            /* use notification payload */
          }
        }

        const notifyClientId =
          getDocumentNotificationClientId(enriched, USER_TYPE) || id;

        if (String(notifyClientId) === String(id)) {
          const documentCategory =
            normalizeDocumentCategoryFromNotification(enriched);
          const documentsTab = getDocumentsFileTypeFromNotification(enriched);
          const nextState = {
            fromNotification: true,
            clientId: notifyClientId,
            documentCategory,
            documentsTab,
            tab: getClientDocumentsActiveTab(documentCategory),
          };
          if (notification_type === "folder") {
            nextState.openFolder = true;
            nextState.folderId = notification_item_id;
          } else {
            nextState.openDocument = true;
            nextState.documentId = notification_item_id;
          }
          documentNotificationSearchRef.current = false;
          navigate(getRolePath(`/client_details/${id}`), {
            state: nextState,
            replace: true,
          });
        } else {
          const route = getDocumentNotificationRoute(enriched, USER_TYPE);
          if (route) {
            navigateToClientDetails(navigate, notifyClientId, {
              state: route.state,
            });
          } else Toaster.error("Could not open documents for this client");
        }
        return;
      }

      if (isMessageNotification(notification)) {
        if (USER_TYPE === "client") {
          const route = getMessageNotificationRoute(notification, USER_TYPE);
          if (route) navigate(route.path, { state: route.state });
          return;
        }
        const clientId =
          getMessageNotificationClientId(notification, USER_TYPE) || id;
        if (clientId && String(clientId) === String(id)) {
          setActiveTab("messages");
        } else if (clientId) {
          navigateToClientDetails(navigate, clientId, {
            state: { tab: "messages" },
          });
        } else {
          Toaster.error("Could not open message thread");
        }
        return;
      }

      if (!ACTION[notification_type]) {
        Toaster.error("Unknown notification type");
        return;
      }

      // Fetch the detail for the notification item
      const response = await ACTION[notification_type][0](notification_item_id);

      if (response.status === 200) {
        // Navigate to the appropriate page
        navigate(ACTION[notification_type][1], {
          state: ["folder", "document"].includes(notification_type)
            ? { clientDetails: response.data.data, fromClientDetails: true }
            : {
                client_id: response.data.data.billed_to,
                mode: notification_type,
                data: response.data.data,
                view: true,
              },
        });
      } else {
        Toaster.error("Error occurred while navigating");
      }
    } catch (error) {
      console.error("Error handling notification click:", error);
      Toaster.error("Error occurred while processing notification");
    }
  };

  // ==================== DOCUMENT HANDLERS ====================

  // File upload handlers
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    const { validFiles, errors } = filterValidDocumentUploadFiles(files);
    errors.forEach((message) => Toaster.error(message));
    if (!validFiles.length) return;
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    setFileData((prevFiles) => [...prevFiles, ...validFiles]);
    if (shouldShowFiledCopiesTagPicker(getFiledCopiesTagPickerContext())) {
      setFiledCopiesFileTags((prevTags) => [
        ...prevTags,
        ...emptyTagsForFileCount(validFiles.length),
      ]);
    }
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFileData((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFiledCopiesFileTags((prevTags) => prevTags.filter((_, i) => i !== index));
  };

  const handleFiledCopiesTagChange = (index, value) => {
    setFiledCopiesFileTags((prevTags) => {
      const next = [...prevTags];
      next[index] = value;
      return next;
    });
  };

  const handleDragOver = (event) => event.preventDefault();

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files || []);
    const { validFiles, errors } = filterValidDocumentUploadFiles(files);
    errors.forEach((message) => Toaster.error(message));
    if (!validFiles.length) return;
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    setFileData((prevFiles) => [...prevFiles, ...validFiles]);
    if (shouldShowFiledCopiesTagPicker(getFiledCopiesTagPickerContext())) {
      setFiledCopiesFileTags((prevTags) => [
        ...prevTags,
        ...emptyTagsForFileCount(validFiles.length),
      ]);
    }
  };

  useEffect(() => {
    if (!showFiledCopiesTagPicker) return;
    setFiledCopiesFileTags((prev) => {
      if (prev.length === fileData.length) return prev;
      if (fileData.length > prev.length) {
        return [...prev, ...emptyTagsForFileCount(fileData.length - prev.length)];
      }
      return prev.slice(0, fileData.length);
    });
  }, [showFiledCopiesTagPicker, fileData.length]);

  useEffect(() => {
    if (!showFiledCopiesTagPicker || !HOME_USER_ID) {
      setFiledCopiesServiceOptions([]);
      setFiledCopiesSelectedServiceId("");
      return undefined;
    }

    let cancelled = false;
    (async () => {
      const data = await CLIENT_ACTION.getClientServices({
        client_id: HOME_USER_ID,
        status: "ongoing",
        service_category: docCategory,
      });
      if (cancelled) return;
      const list = filterRecordsByClientCategory(
        Array.isArray(data) ? data : [],
        docCategory,
      );
      setFiledCopiesServiceOptions(buildClientServiceDropdownOptions(list));
      setFiledCopiesSelectedServiceId("");
    })();

    return () => {
      cancelled = true;
    };
  }, [showFiledCopiesTagPicker, HOME_USER_ID, docCategory, isModalOpen]);

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFiles([]);
    setFileData([]);
    setFiledCopiesFileTags([]);
    setFiledCopiesServiceOptions([]);
    setFiledCopiesSelectedServiceId("");
    setNewFolderName("");
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(false);
    setFolderModalStage("root");
    setFolderModalTitle("");
    setFolderModalReturnStage(null);
    setFolderModalContext(null);
    setFolderModalPath([]);
    setPendingFolders([]);
    setSendNotifications(true);
  };

  const handleFolderModalBack = () => {
    if (folderModalStage === "upload" || folderModalStage === "inner") {
      setFolderModalStage("menu");
      setModalOpen("add_folder");
      return;
    }

    if (!folderModalPath || folderModalPath.length <= 1) {
      handleCloseModal();
      return;
    }

    const nextPath = folderModalPath.slice(0, -1);
    setFolderModalPath(nextPath);
    setFolderModalTitle(nextPath[nextPath.length - 1]?.name || "");
    setFolderModalStage(
      nextPath.length === 1 && nextPath[0]?.id === 0 ? "root" : "menu",
    );
    setModalOpen("add_folder");
  };

  const openFolderModalMenu = (title, returnStage = "root") => {
    setFolderModalTitle(title);
    setFolderModalStage("menu");
    setFolderModalReturnStage(returnStage);
    setNewFolderName("");
    setModalOpen("add_folder");
  };

  const openInnerFolderModal = () => {
    setFolderModalStage("inner");
    setFolderModalReturnStage("menu");
    setNewFolderName("");
    setModalOpen("add_folder");
  };

  const openFolderModalUpload = () => {
    setFolderModalStage("upload");
    setFolderModalReturnStage("menu");
    setModalOpen("add_folder_upload");
  };

  const openUploadSubFolderInput = () => {
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(true);
  };

  const cancelUploadSubFolderInput = () => {
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(false);
  };

  const addUploadSubFolder = () => {
    const folderName = uploadSubFolderName.trim();
    if (!folderName) {
      Toaster.warning("Please enter folder name");
      return;
    }

    let folder_type = "emp";
    if (pendingFolders.length > 0) {
      folder_type = pendingFolders[0].folder_type;
    } else if (isModalOpen === "client_upload") {
      folder_type = "client";
    } else if (isModalOpen === "office_upload") {
      folder_type = "office";
    } else if (isModalOpen === "k1_package_upload") {
      folder_type = DOC_TYPE_K1_PACKAGE;
    } else if (isModalOpen === "filed_copies_upload") {
      folder_type = DOC_TYPE_FILED_COPIES;
    }

    setPendingFolders((prev) => [
      ...prev,
      {
        name: folderName,
        folder_type,
      },
    ]);

    setFolderModalTitle(folderName);
    setUploadSubFolderName("");
    setShowUploadSubFolderInput(false);
  };

  // Open add-folder modal from page toolbar while keeping modal-stage consistent
  const openPageAddFolder = (modalName, returnStage = "menu") => {
    setFolderModalContext(getDocumentModalContextTab());
    // If we're at root/Home, show root dropdown stage, otherwise show inner typable stage
    const isRoot = navPath.length === 1 && navPath[0]?.id === 0;
    setFolderModalStage(isRoot ? "root" : "inner");
    setFolderModalReturnStage(returnStage);
    setNewFolderName("");
    setModalOpen(modalName);
  };

  const openStaffUploadModal = () => {
    setFolderModalContext(getDocumentModalContextTab());
    setModalOpen("emp_upload");
  };

  const getModalPath = () =>
    folderModalPath[folderModalPath.length - 1] || getPath();

  const buildKeyPathFromDirectoryDetails = (directoryDetails) => {
    const keyPathArr = [...directoryDetails];
    keyPathArr.splice(0, 1, { id: 0, name: DOCUMENT_HOME_FOLDER });
    return keyPathArr.map((segment) => segment.name).join("/");
  };

  const handleEmailNotificationChange = (enabled) => {
    setSendNotifications(Boolean(enabled));
  };

  // Folder navigation handler
  const handleOpen = async (
    folder_name,
    folder_id,
    created_by,
    index,
    folder_type,
  ) => {
    let newPath;
    if (index !== undefined) {
      navPath.slice(index + 1).forEach((segment) => {
        if (segment?.id != null) {
          dismissFolderFileHighlights(segment.id, currentDocTab);
        }
      });
      newPath = navPath.slice(0, index + 1);
      setCurrentIndex(index);
    } else {
      newPath = [
        ...navPath,
        {
          id: folder_id,
          name: folder_name,
          created_by: created_by || 0,
          folder_type,
        },
      ];
      setCurrentIndex(navPath.length);
    }
    setNavPath(newPath);

    if (index === undefined && folder_id) {
      clearFolderUnread(folder_id, currentDocTab);
    }
  };

  // Upload file handler
  const uploadFileHandler = async (
    fileDataArray,
    doc_type,
    filedCopiesTags = [],
    filedCopiesServiceId = "",
  ) => {
    if (hasInvalidDocumentUploadFiles(fileDataArray)) {
      Toaster.error(
        `One or more files exceed ${DOCUMENT_UPLOAD_MAX_MB} MB or use a blocked file type.`,
      );
      return;
    }

    let path = getModalPath();
    let uploadDirectoryDetails =
      folderModalPath.length > 0 ? [...folderModalPath] : [...navPath];

    let formData = new FormData();
    for (var i = 0; i <= fileDataArray.length - 1; i++) {
      formData.append("file", fileDataArray[i]);
    }

    formData.append(
      "path",
      buildKeyPathFromDirectoryDetails(uploadDirectoryDetails),
    );
    formData.append("home_folder", HOME_FOLDER);
    formData.append("directory_details", JSON.stringify(uploadDirectoryDetails));
    formData.append("folder_name", path.name);
    formData.append("folder_id", path.id);
    formData.append("doc_type", doc_type);
    formData.append("user_id", HOME_USER_ID);
    formData.append("document_category", docCategory);
    appendBusinessIdToFormData(formData, {
      documentCategory: docCategory,
      clientBusinessId: selectedClientBusinessId,
    });

    if (requiresFiledCopiesDocumentTag(doc_type)) {
      appendFiledCopiesTagsToFormData(formData, fileDataArray, filedCopiesTags);
      appendFiledCopiesServiceToFormData(formData, filedCopiesServiceId);
    }

    // Explicit "true"/"false" strings — multipart booleans become strings; backend must parse strictly.
    const shouldSendEmail =
      !isInternalPurposeDocType(doc_type) && Boolean(sendNotifications);
    formData.append("send_email", shouldSendEmail ? "true" : "false");

    if (isClient) {
      const USER_DATA = JSON.parse(localStorage.getItem("USER_DATA") || "{}");
      formData.append("to_email", USER_DATA.employee_email || "");
      formData.append("first_name", USER_DATA.employee || "");
      formData.append("user_role", "client");
    } else {
      formData.append("to_email", clientData.email || "");
      formData.append("first_name", clientData.first_name || "");
      formData.append("user_role", "employee");
    }

    let createdPath = path;

    if (pendingFolders.length > 0) {
      for (const folder of pendingFolders) {
        const folderResponse = await DOCUMENT_ACTION.createFolder(
          appendDocScope({
            user_id: HOME_USER_ID,
            folderName: folder.name,
            parentFolderName: createdPath.name,
            parentFolderId: createdPath.id,
            folder_type: folder.folder_type,
            path: buildKeyPathFromDirectoryDetails(uploadDirectoryDetails),
            home_folder: HOME_FOLDER,
            directory_details: JSON.stringify(uploadDirectoryDetails),
            document_category: docCategory,
          }),
        );

        if (folderResponse.status === 200 && folderResponse.data.status === 1) {
          const createdFolder = folderResponse.data.data;

          createdPath = {
            id:
              createdFolder.client_folder_id ??
              createdFolder.folder_id ??
              createdFolder.id,
            name: createdFolder.folder_name || folder.name,
            created_by: createdFolder.created_by || 0,
            folder_type: folder.folder_type,
          };
          uploadDirectoryDetails = [...uploadDirectoryDetails, createdPath];
        } else {
          Toaster.error("Error occurred while creating the folder");
          return;
        }
      }

      formData.set("folder_name", createdPath.name);
      formData.set("folder_id", createdPath.id);
      formData.set("directory_details", JSON.stringify(uploadDirectoryDetails));
      formData.set(
        "path",
        buildKeyPathFromDirectoryDetails(uploadDirectoryDetails),
      );
    }

    try {
      const response = await DOCUMENT_ACTION.uploadFile({ formData });
      if (response.status === 200 && response.data.status === 1) {
        if (
          requiresFiledCopiesDocumentTag(doc_type) &&
          filedCopiesServiceId
        ) {
          const serviceRes = await markFiledCopiesServiceCompleted({
            updateClientServiceStatus: CLIENT_ACTION.updateClientServiceStatus,
            clientId: HOME_USER_ID,
            clientServiceId: filedCopiesServiceId,
          });
          if (serviceRes?.status !== 1) {
            Toaster.warning(
              serviceRes?.message ||
                "Document uploaded but could not mark the service as completed",
            );
          }
        }

        Toaster.success("Document Uploaded Successfully");

        const refreshPath = getPath();

        await Promise.all([
          dispatch(
            DOCUMENT_ACTION.getUserFolders(
              appendDocScope({
                user_id: HOME_USER_ID,
                folder_name: refreshPath.name,
                folder_id: refreshPath.id,
                document_category: docCategory,
              }),
            ),
          ),
          dispatch(
            DOCUMENT_ACTION.getUserFiles(
              appendDocScope({
                user_id: HOME_USER_ID,
                folder_name: refreshPath.name,
                folder_id: refreshPath.id,
                document_category: docCategory,
              }),
            ),
          ),
        ]);
        handleCloseModal();
      } else {
        Toaster.error("Error occurred while uploading the document");
      }
    } catch (error) {
      Toaster.error("Error occurred while uploading the document");
    }
  };

  // Create folder handler
  const createFolderHandler = async (
    folderName,
    folder_type,
    keepModalOpen = false,
    nextMenuTitle = null,
  ) => {
    let path = getModalPath();
    const directoryDetailsForCreate =
      folderModalPath.length > 0 ? folderModalPath : navPath;
    try {
      const response = await DOCUMENT_ACTION.createFolder(
        appendDocScope({
          user_id: HOME_USER_ID,
          folderName: folderName,
          parentFolderName: path.name,
          parentFolderId: path.id,
          folder_type: folder_type,
          path: buildKeyPathFromDirectoryDetails(directoryDetailsForCreate),
          home_folder: HOME_FOLDER,
          directory_details: JSON.stringify(directoryDetailsForCreate),
          document_category: docCategory,
        }),
      );

      if (response.status === 200 && response.data.status === 1) {
        Toaster.success("Folder created successfully");
        const createdFolder = response.data?.data || {};

        const activeFolder = createdFolder
          ? {
              id:
                createdFolder.client_folder_id ??
                createdFolder.folder_id ??
                createdFolder.id,
              name: createdFolder.folder_name || folderName,
              created_by: createdFolder.created_by || 0,
              folder_type: createdFolder.folder_type,
            }
          : {
              id: null,
              name: folderName,
              created_by: 0,
              folder_type,
            };

        // Refresh folders for the current page path so new folders appear immediately.
        try {
          const pagePath = getPath();
          await Promise.all([
            dispatch(
              DOCUMENT_ACTION.getUserFolders(
                appendDocScope({
                  user_id: HOME_USER_ID,
                  folder_name: pagePath.name,
                  folder_id: pagePath.id,
                  folder_type: "client",
                  document_category: docCategory,
                }),
              ),
            ),
            dispatch(
              DOCUMENT_ACTION.getUserFolders(
                appendDocScope({
                  user_id: HOME_USER_ID,
                  folder_name: pagePath.name,
                  folder_id: pagePath.id,
                  folder_type: "emp",
                  document_category: docCategory,
                }),
              ),
            ),
          ]);
        } catch (refreshErr) {
          // non-fatal: UI will update on next automatic refresh
          console.error("Error refreshing folders after create:", refreshErr);
        }

        if (keepModalOpen) {
          setNewFolderName("");
          setFolderModalPath((prev) => {
            if (folderModalStage === "root" || prev.length === 0) {
              return [{ id: 0, name: "Home", created_by: 0 }, activeFolder];
            }
            return [...prev, activeFolder];
          });
          setFolderModalTitle(activeFolder.name);
          setFolderModalStage("menu");
          setFolderModalReturnStage(null);
          setFolderModalContext(activeFolder);
          setModalOpen("add_folder");
        } else {
          handleCloseModal();
        }
      } else {
        Toaster.error("Error occurred while creating the folder");
      }
    } catch (err) {
      Toaster.error("Error occurred while creating the folder");
    }
  };

  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    docdata: null,
    folder_name: "",
    document_name: "",
  });

  const [deleteFolderDialog, setDeleteFolderDialog] = useState({
    open: false,
    folderData: null,
  });
  const [deleteCommentDialog, setDeleteCommentDialog] = useState({
    open: false,
    comment: null,
  });

  // Delete file handler (opens modal)
  const handleDeleteFile = (docdata, folder_name, document_name) => {
    setDeleteDialog({
      open: true,
      docdata,
      folder_name,
      document_name,
    });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({
      open: false,
      docdata: null,
      folder_name: "",
      document_name: "",
    });
  };

  const confirmDeleteFile = async () => {
    if (!deleteDialog.docdata) return;
    const path = getPath();
    try {
      await DOCUMENT_ACTION.deleteFile(
        deleteDialog.docdata["client_document_id"],
        deleteDialog.folder_name,
        deleteDialog.document_name,
      );

      // Optimistically remove from local state for immediate UI update
      const targetDocId = deleteDialog.docdata.client_document_id;
      setFileStructure((prev) => ({
        ...prev,
        files: prev.files.filter((f) => f.client_document_id !== targetDocId),
      }));

      dispatch(
        DOCUMENT_ACTION.getUserFiles(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: deleteDialog.folder_name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );
    } catch (error) {
      console.error("Error deleting item:", error);
      Toaster.error("Error occurred while deleting document");
    } finally {
      closeDeleteDialog();
    }
  };

  // Rename file handler
  const handleRenameFile = async (docdata, newName) => {
    let formData = new FormData();
    let path = getPath();

    formData.append("client_document_id", docdata.client_document_id);
    formData.append("folder_name", docdata.folder_name);
    formData.append("document_name", docdata.document_name);
    const safeName = getFileNameWithoutExtension(newName);

    // 🔒 Send ONLY base name — NO extension
    formData.append("new_document_name", safeName);

    formData.append("home_folder", HOME_FOLDER);
    formData.append("user_id", HOME_USER_ID);
    formData.append("client_folder_id", docdata.client_folder_id);
    formData.append("first_name", docdata.first_name || "");
    formData.append("last_name", docdata.last_name || "");
    formData.append(
      "directory_details",
      docdata.directory_details || JSON.stringify(navPath),
    );
    formData.append("document_type", docdata.document_type || "");
    formData.append("doc_type", docdata.doc_type || "");
    formData.append("document_extension", docdata.document_extension || "");
    formData.append("document_link", docdata.document_link || "");
    formData.append("document_size", docdata.document_size || "");
    formData.append("status", docdata.status || 1);

    try {
      const response = await DOCUMENT_ACTION.renameFile(formData);
      if (response.status === 200) {
        Toaster.success("Document renamed successfully!");
        setRenameModalOpen(false);
        setNewName("");

        // Optimistically update local state for immediate UI feedback
        const renamedId = docdata.client_document_id;
        setFileStructure((prev) => ({
          ...prev,
          files: prev.files.map((f) =>
            f.client_document_id === renamedId
              ? { ...f, document_name: safeName }
              : f,
          ),
        }));

        dispatch(
          DOCUMENT_ACTION.getUserFiles(
            appendDocScope({
              folder_id: path.id,
              folder_name: docdata.folder_name,
              user_id: HOME_USER_ID,
              document_category: docCategory,
            }),
          ),
        );
      } else {
        Toaster.error("Failed to rename the file.");
        setRenameModalOpen(false);
      }
    } catch (error) {
      console.error("Error renaming file:", error);
      Toaster.error("Error occurred while renaming.");
    }
  };

  // View/Download file handler
  const viewDownloadFileHandler = async (
    type,
    {
      folder_name,
      document_name,
      document_type,
      client_document_id,
      client_folder_id,
      // For downloaded files, pass the full file object to construct correct path
      ...fileData
    },
  ) => {
    if (type === "Delete") {
      const docdata = userFiles.find(
        (file) => file.document_name === document_name,
      );
      if (docdata) {
        handleDeleteFile(docdata, folder_name, document_name);
      }
      return;
    }

    if (type === "Preview" && client_document_id) {
      dismissFileHighlight(client_document_id);
    }

    // If this is a downloaded file (has directory_details or folder_path), use its actual path
    // Otherwise, use current navigation path
    let fileURL;
    if (
      fileData.directory_details ||
      fileData.folder_path ||
      fileData.folder_name
    ) {
      const constructedURL = buildFileURLFromDocument({
        document_name,
        directory_details: fileData.directory_details,
        folder_path: fileData.folder_path,
        folder_name: fileData.folder_name,
      });
      fileURL = constructedURL || `${getKeyPath()}/${document_name}`;
    } else {
      fileURL = `${getKeyPath()}/${document_name}`;
    }

    const previewTab = type === "Preview" ? openDocumentPreviewTab() : null;
    const response = await DOCUMENT_ACTION.downloadViewFile({
      fileURL,
      folder_name: folder_name || fileData.folder_name,
      document_name,
      document_type,
      client_document_id,
      type,
    });

    if (type === "Preview") {
      await openDocumentInNewTab(
        response?.raw,
        document_type,
        document_name,
        previewTab,
      );
    }

    if (response.status === 200) {
      // Refresh current folder files + folders so API-driven `downloaded` updates reflect immediately
      dispatch(
        DOCUMENT_ACTION.getUserFolders(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: folder_name,
            folder_id: client_folder_id,
            document_category: docCategory,
          }),
        ),
      );
      dispatch(
        DOCUMENT_ACTION.getUserFiles(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: folder_name,
            folder_id: client_folder_id,
            document_category: docCategory,
          }),
        ),
      );

      if (type === "Download") {
        // Trigger downloaded section refresh (folder download should become true via API)
        setDownloadedRefreshKey((k) => k + 1);
      }
    }
  };

  // Deep-link from document/folder upload notifications
  useEffect(() => {
    if (
      !location.state?.fromNotification ||
      !id ||
      !clientData ||
      !HOME_FOLDER ||
      documentNotificationSearchRef.current
    ) {
      return;
    }

    const documentCategory =
      location.state.documentCategory ||
      normalizeDocumentCategoryFromNotification(location.state);
    const documentsTab =
      location.state.documentsTab ||
      getDocumentsFileTypeFromNotification(location.state);

    setActiveTab(getClientDocumentsActiveTab(documentCategory));
    setCategoryTab(normalizeClientDetailCategory(documentCategory));
    setDocFileType(documentsTab);

    const performSearch = async () => {
      documentNotificationSearchRef.current = true;
      const clientId = location.state?.clientId || id;
      const homeFolder =
        clientData.s3_root_folder || clientData.home_folder || HOME_FOLDER;

      try {
        if (location.state?.openFolder && location.state?.folderId) {
          const result = await searchFolderRecursively({
            dispatch,
            documentAction: DOCUMENT_ACTION,
            targetFolderId: location.state.folderId,
            searchUserId: clientId,
            searchHomeFolder: homeFolder,
            documentCategory,
          });
          if (result?.folderNavPath) {
            setNavPath(result.folderNavPath);
            setCurrentIndex(result.folderNavPath.length - 1);
          }
        } else if (
          location.state?.openDocument &&
          location.state?.documentId
        ) {
          documentOpenedFromNotificationRef.current = true;
          const result = await searchDocumentRecursively({
            dispatch,
            documentAction: DOCUMENT_ACTION,
            targetDocumentId: location.state.documentId,
            searchUserId: clientId,
            searchHomeFolder: homeFolder,
            documentCategory,
          });
          if (result?.folderNavPath) {
            setNavPath(result.folderNavPath);
            setCurrentIndex(result.folderNavPath.length - 1);
          } else {
            documentOpenedFromNotificationRef.current = false;
          }
        }
      } finally {
        documentNotificationSearchRef.current = false;
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };

    performSearch();
  }, [
    location.state?.fromNotification,
    location.state?.folderId,
    location.state?.documentId,
    location.state?.clientId,
    location.state?.documentCategory,
    id,
    clientData,
    HOME_FOLDER,
    dispatch,
  ]);

  // Open document preview after notification navigation loads files
  useEffect(() => {
    if (
      !location.state?.fromNotification ||
      !location.state?.openDocument ||
      !location.state?.documentId ||
      !documentOpenedFromNotificationRef.current ||
      !userFiles?.length
    ) {
      return;
    }

    const documentToOpen = userFiles.find(
      (file) =>
        String(file.client_document_id) === String(location.state.documentId),
    );

    if (documentToOpen) {
      const timer = setTimeout(() => {
        viewDownloadFileHandler("Preview", documentToOpen);
        documentOpenedFromNotificationRef.current = false;
        window.history.replaceState({}, document.title, window.location.pathname);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [userFiles, location.state, navPath]);

  // Rename folder handler
  const handleRenameFolder = async (folderData, newName) => {
    const path = getPath();
    try {
      await dispatch(
        DOCUMENT_ACTION.renameFolder({
          folder_id: folderData.folder_id || folderData.client_folder_id,
          folder_name: folderData.folder_name,
          new_folder_name: newName,
          oldFolderPath: folderData.s3_folder_location || "",
          home_folder: folderData.home_folder || HOME_FOLDER,
          newFolderPath: `https://finlotax-user-docs.s3.us-west-1.amazonaws.com/${getKeyPath()}/${newName}`,
          userId: HOME_USER_ID,
        }),
      ).unwrap();

      // Optimistically update local state for immediate UI feedback
      const targetFolderId =
        folderData.client_folder_id !== undefined
          ? folderData.client_folder_id
          : folderData.folder_id;
      setFileStructure((prev) => ({
        ...prev,
        folders: prev.folders.map((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId === targetFolderId
            ? { ...f, folder_name: newName }
            : f;
        }),
      }));
      setHomeFolders((prev) =>
        prev.map((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId === targetFolderId
            ? { ...f, folder_name: newName }
            : f;
        }),
      );

      dispatch(
        DOCUMENT_ACTION.getUserFolders(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );

      Toaster.success("Folder renamed successfully!");
      setRenameFolderModalOpen(false);
      setNewName("");
    } catch (error) {
      console.error("Error renaming folder:", error);
      Toaster.error("Failed to rename folder.");
      setRenameFolderModalOpen(false);
    }
  };

  // Delete folder handler (opens modal)
  const handleDeleteFolder = (folderData) => {
    setDeleteFolderDialog({
      open: true,
      folderData,
    });
  };

  const closeDeleteFolderDialog = () => {
    setDeleteFolderDialog({
      open: false,
      folderData: null,
    });
  };

  const confirmDeleteFolder = async () => {
    if (!deleteFolderDialog.folderData) return;
    const folderData = deleteFolderDialog.folderData;
    const path = getPath();
    try {
      await dispatch(
        DOCUMENT_ACTION.deleteFolder({
          folder_id: folderData.folder_id || folderData.client_folder_id,
          folder_name: folderData.folder_name,
          folderPath: folderData.s3_folder_location || "",
          home_folder: folderData.home_folder || HOME_FOLDER,
          userId: HOME_USER_ID,
        }),
      ).unwrap();

      // Optimistically remove from local state for immediate UI update
      const targetFolderId =
        folderData.client_folder_id !== undefined
          ? folderData.client_folder_id
          : folderData.folder_id;
      setFileStructure((prev) => ({
        ...prev,
        folders: prev.folders.filter((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId !== targetFolderId;
        }),
      }));
      setHomeFolders((prev) =>
        prev.filter((f) => {
          const currentId =
            f.client_folder_id !== undefined ? f.client_folder_id : f.folder_id;
          return currentId !== targetFolderId;
        }),
      );

      dispatch(
        DOCUMENT_ACTION.getUserFolders(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );
    } catch (error) {
      console.error("Error deleting folder:", error);
      Toaster.error("Failed to delete folder.");
    } finally {
      closeDeleteFolderDialog();
    }
  };

  // Delete comment handler (opens modal)
  const handleDeleteComment = (comment) => {
    setDeleteCommentDialog({
      open: true,
      comment,
    });
  };

  const closeDeleteCommentDialog = () => {
    setDeleteCommentDialog({
      open: false,
      comment: null,
    });
  };

  const confirmDeleteComment = async () => {
    if (!deleteCommentDialog.comment || !id) return;
    const comment = deleteCommentDialog.comment;
    try {
      const result = await CLIENT_ACTION.deleteClientComment(
        comment.comment_id || comment.id,
      );

      if (result?.data?.status === 1) {
        Toaster.success("Comment deleted successfully");
        // Refresh comments list
        const commentsData = await dispatch(
          CLIENT_ACTION.getClientComments({
            clientId: id,
            category: categoryTab,
          }),
        ).unwrap();
        setCommentsList(commentsData || []);
      } else {
        Toaster.error(result?.data?.message || "Failed to delete comment");
      }
    } catch (error) {
      Toaster.error("Error deleting comment. Please try again.");
    } finally {
      closeDeleteCommentDialog();
    }
  };

  // Bulk download handler
  const bulkDownloadHandler = async ({ folder_name, folder_id }) => {
    DOCUMENT_ACTION.getBulkFiles({
      user_id: HOME_USER_ID,
      folder_name,
      folder_id,
      path: getKeyPath(),
    });
    // Best-effort refresh (bulk download may mark folder/docs downloaded in API)
    try {
      const path = getPath();
      dispatch(
        DOCUMENT_ACTION.getUserFolders(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: path.name === "Home" ? HOME_FOLDER : path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );
      dispatch(
        DOCUMENT_ACTION.getUserFiles(
          appendDocScope({
            user_id: HOME_USER_ID,
            folder_name: path.name === "Home" ? HOME_FOLDER : path.name,
            folder_id: path.id,
            document_category: docCategory,
          }),
        ),
      );
      setDownloadedRefreshKey((k) => k + 1);
    } catch (e) {}
  };

  // ----- Downloaded section (API-driven, single endpoint) -----
  const buildFolderPathFromDirectoryDetails = (directoryDetails) => {
    if (!directoryDetails) return "Home";
    try {
      const arr =
        typeof directoryDetails === "string"
          ? JSON.parse(directoryDetails)
          : directoryDetails;
      const parts = (arr || [])
        .slice(1)
        .map((p) => p?.name)
        .filter(Boolean);
      return parts.length ? parts.join(" > ") : "Home";
    } catch (e) {
      return "Home";
    }
  };

  const getDocumentFolderPath = (doc) => {
    if (!doc) return "Home";
    if (doc.folder_path) return doc.folder_path;
    if (doc.directory_details)
      return buildFolderPathFromDirectoryDetails(doc.directory_details);
    if (doc.folder_name) return doc.folder_name;
    return "Home";
  };

  // Build full file URL path from document's folder structure
  const buildFileURLFromDocument = (doc) => {
    if (!doc) return null;

    // If document has directory_details, use it to build the full path
    if (doc.directory_details) {
      try {
        const arr =
          typeof doc.directory_details === "string"
            ? JSON.parse(doc.directory_details)
            : doc.directory_details;

        if (Array.isArray(arr) && arr.length > 0) {
          // Replace first item (Home) with actual HOME_FOLDER
          const pathArr = [...arr];
          pathArr[0] = { ...pathArr[0], name: DOCUMENT_HOME_FOLDER };
          const fullPath = pathArr
            .map((p) => p?.name)
            .filter(Boolean)
            .join("/");
          return `${fullPath}/${doc.document_name}`;
        }
      } catch (e) {
        console.error("Error parsing directory_details:", e);
      }
    }

    // Fallback: if we have folder_name, construct path
    if (doc.folder_name && doc.folder_name !== HOME_FOLDER) {
      return `${HOME_FOLDER}/${doc.folder_name}/${doc.document_name}`;
    }

    // Default: file is in root
    return `${HOME_FOLDER}/${doc.document_name}`;
  };

  useEffect(() => {
    if (!HOME_USER_ID) return;
    if (!isDocumentsTab) return;
    if (!isDocumentsFolderTab(docFileType)) return;
    let cancelled = false;
    const run = async () => {
      // Only show loading if we don't have data yet or we're explicitly refreshing
      if (downloadedItems.length === 0 || downloadedRefreshKey > 0) {
        setIsDownloadedLoading(true);
      }
      try {
        await dispatch(
          DOCUMENT_ACTION.getAllClientDocuments(
            appendDocScope({
              user_id: HOME_USER_ID,
              document_category: docCategory,
            }),
          ),
        );
      } finally {
        if (!cancelled) setIsDownloadedLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    HOME_USER_ID,
    isDocumentsTab,
    docCategory,
    downloadedRefreshKey,
    docFileType,
    selectedClientBusinessId,
    appendDocScope,
  ]);

  useEffect(() => {
    if (!isDocumentsTab) return;
    if (!isDocumentsFolderTab(docFileType)) {
      setDownloadedItems([]);
      return;
    }
    const all = Array.isArray(allClientDocuments) ? allClientDocuments : [];

    const wantedDocType = getWantedDocTypeForPurposeTab(docFileType);

    // Get current folder ID from navPath
    const currentFolderId = navPath[navPath.length - 1]?.id;

    const downloaded = all
      .filter((d) => Number(d.downloaded) === 1)
      .filter((d) => recordMatchesBusinessScope(d, selectedClientBusinessId))
      // Filter by current folder: only show documents from the folder we're currently viewing
      .filter((d) => {
        // Compare folder IDs - documents should belong to current folder
        const docFolderId = d.client_folder_id;
        return docFolderId === currentFolderId;
      })
      .filter((d) => (wantedDocType ? d.doc_type === wantedDocType : true))
      .map((d) => ({ ...d, __folderPath: getDocumentFolderPath(d) }));

    const byId = new Map();
    for (const d of downloaded) {
      const key =
        d.client_document_id || `${d.document_name}-${d.__folderPath}`;
      byId.set(key, d);
    }
    const finalList = Array.from(byId.values()).sort((a, b) => {
      const da = new Date(a.updatedAt || a.createdAt || 0).getTime();
      const db = new Date(b.updatedAt || b.createdAt || 0).getTime();
      return db - da;
    });
    setDownloadedItems(finalList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allClientDocuments, docFileType, isDocumentsTab, docCategory, navPath]);

  const renderDownloadedSection = () => {
    if (!isDocumentsFolderTab(docFileType)) return null;
    // Only show downloaded section when inside a folder (not at root/Home)
    const isAtRoot = navPath.length === 1 && navPath[0]?.id === 0;
    if (isAtRoot) return null;

    if (
      !isDownloadedLoading &&
      (!downloadedItems || downloadedItems.length === 0)
    )
      return null;

    return (
      <div
        className="documents-section downloaded-files"
        style={{ marginTop: 16 }}
      >
        <div className="documents-section-header">
          <h3 className="documents-section-title">Downloaded Documents</h3>
          <IconButton
            className={`documents-section-toggle ${isDownloadedOpen ? "open" : ""}`}
            onClick={() => setIsDownloadedOpen((v) => !v)}
            size="small"
          >
            <ExpandMore />
          </IconButton>
        </div>

        {isDownloadedOpen && (
          <div className="documents-section-content">
            <table className="documents-table">
              <thead>
                <tr>
                  <th style={{ width: "38%" }}>Document</th>
                  <th style={{ width: "14%" }}>Date</th>
                  <th style={{ width: "14%" }}>Created At</th>
                  <th style={{ width: "14%" }}>File Type</th>
                  <th style={{ width: "10%", textAlign: "right" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {isDownloadedLoading ? (
                  <tr>
                    <td colSpan={5} className="documents-empty-cell">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  downloadedItems.map((data) => {
                    const folderPath =
                      data.__folderPath && data.__folderPath !== "Home"
                        ? data.__folderPath
                        : null;
                    return (
                      <tr
                        key={`downloaded-${data.client_document_id}-${data.__folderPath}`}
                        className="documents-row"
                        onClick={() => viewDownloadFileHandler("Preview", data)}
                      >
                        <td className="doc-name-cell">
                          {getFileTypeIcon(normalizeMimeType(data))}
                          <div className="doc-name-text">
                            <div className="doc-name-primary">
                              {data.document_name}
                            </div>
                            {folderPath && (
                              <div className="doc-name-secondary">
                                {folderPath}
                              </div>
                            )}
                          </div>
                        </td>
                        <td>{dateTimeFormatter(data.updatedAt)}</td>
                        <td>{formatDocumentCreatedAt(data)}</td>
                        <td>{getReadableFileType(normalizeMimeType(data))}</td>
                        <td
                          className="doc-action-cell"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <IconButton
                            onClick={() =>
                              viewDownloadFileHandler("Download", data)
                            }
                          >
                            <GetApp fontSize="small" />
                          </IconButton>
                          <FileActionMenu fileData={data} />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const handleCreateFolderDirectly = () => {
    if (newFolderName.trim() === "") {
      Toaster.warning("Please select folder name");
      return;
    }
    let folder_type = "emp";
    if (isModalOpen === "client_add_folder") {
      folder_type = "client";
    } else if (isModalOpen === "office_add_folder") {
      folder_type = "office";
    } else if (isModalOpen === "k1_package_add_folder") {
      folder_type = DOC_TYPE_K1_PACKAGE;
    } else if (isModalOpen === "filed_copies_add_folder") {
      folder_type = DOC_TYPE_FILED_COPIES;
    } else if (!isClient) {
      folder_type = resolveStaffDocType(getDocumentModalContextTab());
    }
    createFolderHandler(newFolderName.trim(), folder_type, false, null);
  };

  // Modal action handler
  const modelAction = () => {
    let folder_type = "emp";
    let doc_type = "emp";
    const isPageAddFolderModal = [
      "client_add_folder",
      "emp_add_folder",
      "office_add_folder",
      "k1_package_add_folder",
      "filed_copies_add_folder",
    ].includes(isModalOpen);

    if (isModalOpen.includes("_upload")) {
      if (fileData.length === 0) {
        Toaster.warning("Please upload document");
        return;
      }
      if (isModalOpen === "client_upload") {
        doc_type = "client";
      } else if (isModalOpen === "office_upload") {
        doc_type = "office";
      } else if (isModalOpen === "k1_package_upload") {
        doc_type = DOC_TYPE_K1_PACKAGE;
      } else if (isModalOpen === "filed_copies_upload") {
        doc_type = DOC_TYPE_FILED_COPIES;
      } else if (
        isModalOpen === "emp_upload" ||
        isModalOpen === "add_folder_upload"
      ) {
        doc_type = isClient
          ? "emp"
          : resolveStaffDocType(getDocumentModalContextTab());
      }
      const tagValidationError = requiresFiledCopiesDocumentTag(doc_type)
        ? validateFiledCopiesUpload({
            files: fileData,
            tags: filedCopiesFileTags,
            clientServiceId: filedCopiesSelectedServiceId,
          })
        : null;
      if (tagValidationError) {
        Toaster.warning(tagValidationError);
        return;
      }
      uploadFileHandler(
        fileData,
        doc_type,
        filedCopiesFileTags,
        filedCopiesSelectedServiceId,
      );
      return;
    }

    if (isPageAddFolderModal) {
      if (newFolderName.trim() === "") {
        Toaster.warning("Please enter folder name");
        return;
      }

      if (isModalOpen === "client_add_folder") {
        folder_type = "client";
      } else if (isModalOpen === "office_add_folder") {
        folder_type = "office";
      } else if (isModalOpen === "k1_package_add_folder") {
        folder_type = DOC_TYPE_K1_PACKAGE;
      } else if (isModalOpen === "filed_copies_add_folder") {
        folder_type = DOC_TYPE_FILED_COPIES;
      } else if (!isClient) {
        folder_type = resolveStaffDocType(getDocumentModalContextTab());
      }

      const isRootFolderContext = navPath.length === 1 && navPath[0]?.id === 0;
      if (isRootFolderContext) {
        const existingFolder = (userFolders || []).find(
          (f) =>
            f.folder_name?.trim().toLowerCase() ===
              newFolderName.trim().toLowerCase() &&
            matchesPurposeTabFolder(f, docFileType),
        );

        if (existingFolder) {
          const activeFolder = {
            id:
              existingFolder.client_folder_id ??
              existingFolder.folder_id ??
              existingFolder.id,
            name: existingFolder.folder_name,
            created_by: existingFolder.created_by || 0,
            folder_type: existingFolder.folder_type,
          };
          setFolderModalPath([
            { id: 0, name: "Home", created_by: 0 },
            activeFolder,
          ]);
          setFolderModalTitle(activeFolder.name);
          setFolderModalStage("upload");
          setFolderModalReturnStage("root");
          setNewFolderName("");
          setModalOpen("add_folder_upload");
          return;
        }

        setPendingFolders((prev) => [
          ...prev,
          {
            name: newFolderName.trim(),
            folder_type,
          },
        ]);

        setFolderModalTitle(newFolderName.trim());
        setFolderModalStage("upload");
        setFolderModalReturnStage("root");
        setNewFolderName("");
        setModalOpen("add_folder_upload");
        return;
      }

      createFolderHandler(newFolderName.trim(), folder_type, false, null);
      return;
    }

    if (isModalOpen.includes("add_folder")) {
      const isRootFolderContext = navPath.length === 1 && navPath[0]?.id === 0;
      if (isRootFolderContext && folderModalStage === "root") {
        if (newFolderName.trim() === "") {
          Toaster.warning("Please select folder name");
          return;
        }

        if (isModalOpen === "client_add_folder") {
          folder_type = "client";
        } else if (isModalOpen === "office_add_folder") {
          folder_type = "office";
        } else if (!isClient) {
          folder_type = resolveStaffDocType(getDocumentModalContextTab());
        }

        const existingFolder = (userFolders || []).find(
          (f) =>
            f.folder_name?.trim().toLowerCase() ===
              newFolderName.trim().toLowerCase() &&
            matchesPurposeTabFolder(f, docFileType),
        );

        if (existingFolder) {
          const activeFolder = {
            id:
              existingFolder.client_folder_id ??
              existingFolder.folder_id ??
              existingFolder.id,
            name: existingFolder.folder_name,
            created_by: existingFolder.created_by || 0,
            folder_type: existingFolder.folder_type,
          };
          setFolderModalPath([
            { id: 0, name: "Home", created_by: 0 },
            activeFolder,
          ]);
          setFolderModalTitle(activeFolder.name);
          setFolderModalStage("upload");
          setFolderModalReturnStage("root");
          setNewFolderName("");
          setModalOpen("add_folder_upload");
          return;
        }

        setPendingFolders((prev) => [
          ...prev,
          {
            name: newFolderName.trim(),
            folder_type,
          },
        ]);

        setFolderModalTitle(newFolderName.trim());
        setFolderModalStage("upload");
        setFolderModalReturnStage("root");
        setNewFolderName("");
        setModalOpen("add_folder_upload");
        return;
      }

      if (folderModalStage === "inner" && newFolderName.trim() === "") {
        Toaster.warning("Please enter folder name");
        return;
      }

      if (folderModalStage !== "inner") {
        return;
      }

      if (isModalOpen === "client_add_folder") {
        folder_type = "client";
      } else if (isModalOpen === "office_add_folder") {
        folder_type = "office";
      } else if (isModalOpen === "k1_package_add_folder") {
        folder_type = DOC_TYPE_K1_PACKAGE;
      } else if (isModalOpen === "filed_copies_add_folder") {
        folder_type = DOC_TYPE_FILED_COPIES;
      } else if (!isClient) {
        folder_type = resolveStaffDocType(getDocumentModalContextTab());
      }
      setPendingFolders((prev) => [
        ...prev,
        {
          name: newFolderName.trim(),
          folder_type,
        },
      ]);

      setFolderModalTitle(newFolderName.trim());
      setFolderModalStage("menu");
      setNewFolderName("");
      setModalOpen("add_folder");
    }
  };

  const openMoveModal = (type, data) => {
    setMoveItem({ type, data });
    setMoveModalOpen(true);
  };

  const closeMoveModal = () => {
    setMoveModalOpen(false);
    setMoveItem(null);
  };

  const refreshAfterMove = async () => {
    setDownloadedRefreshKey((k) => k + 1);
    const path = getPath();
    dispatch(
      DOCUMENT_ACTION.getUserFolders(
        appendDocScope({
          user_id: id,
          folder_name: path.name,
          folder_id: path.id,
          document_category: docCategory,
        }),
      ),
    );
    dispatch(
      DOCUMENT_ACTION.getUserFiles(
        appendDocScope({
          user_id: id,
          folder_name: path.name,
          folder_id: path.id,
          document_category: docCategory,
        }),
      ),
    );
  };

  const handleMoveConfirm = async ({
    destination,
    documentCategory: destCategory,
    docType: destDocType,
  }) => {
    if (!moveItem) return;
    const dest = destination || {};
    const sourceItem = moveItem.data || {};
    const sourceDocType =
      moveItem.type === "folder"
        ? sourceItem.folder_type
        : sourceItem.doc_type;
    const sourceCategory = sourceItem.document_category || docCategory;
    const targetCategory = destCategory ?? sourceCategory;

    try {
      if (moveItem.type === "folder") {
        const folder = sourceItem;
        const folderId =
          folder.client_folder_id ?? folder.folder_id ?? folder.id;
        const response = await DOCUMENT_ACTION.moveFolder(
          appendDocScope({
            folder_id: folderId,
            new_parent_folder_id: dest.id || 0,
            user_id: id,
            home_folder: HOME_FOLDER,
            doc_type: destDocType || folder.folder_type,
            new_doc_type: destDocType,
            document_category: targetCategory,
            new_document_category: destCategory,
            source_doc_type: sourceDocType,
            source_document_category: sourceCategory,
            new_parent_folder_name: dest.name,
            new_directory_details: JSON.stringify(dest.navPath || []),
          }),
        );
        if (response?.status === 200 && response?.data?.status === 1) {
          Toaster.success("Folder moved successfully");
          await refreshAfterMove();
          closeMoveModal();
        } else {
          Toaster.error(
            response?.data?.message || "Error occurred while moving the folder",
          );
        }
      } else {
        const file = moveItem.data || {};
        const response = await DOCUMENT_ACTION.moveFile(
          appendDocScope({
            client_document_id: file.client_document_id,
            new_folder_id: dest.id || 0,
            new_folder_name: dest.name,
            user_id: id,
            home_folder: HOME_FOLDER,
            doc_type: destDocType || file.doc_type,
            new_doc_type: destDocType,
            document_category: targetCategory,
            new_document_category: destCategory,
            source_doc_type: sourceDocType,
            source_document_category: sourceCategory,
            new_directory_details: JSON.stringify(dest.navPath || []),
          }),
        );
        if (response?.status === 200 && response?.data?.status === 1) {
          Toaster.success("File moved successfully");
          await refreshAfterMove();
          closeMoveModal();
        } else {
          Toaster.error(
            response?.data?.message || "Error occurred while moving the file",
          );
        }
      }
    } catch (e) {
      Toaster.error("Error occurred while moving the item");
    }
  };

  // File action menu component
  const FileActionMenu = ({ fileData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleRenameClick = () => {
      setSelectedFile(fileData);
      setNewName(getFileNameWithoutExtension(fileData.document_name || ""));

      setRenameModalOpen(true);
      handleMenuClose();
    };

    const handleMoveClick = () => {
      openMoveModal("file", fileData);
      handleMenuClose();
    };

    const handleSendForSignatureClick = () => {
      setSignatureModal({ open: true, document: fileData });
      handleMenuClose();
    };

    const documentName = fileData.document_name || fileData.name || "";
    const canSendForSignature =
      !isClient && isSignableDocumentName(documentName);

    return (
      <>
        <IconButton onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem
            onClick={() => viewDownloadFileHandler("Preview", fileData)}
          >
            <ListItemIcon>
              <Visibility fontSize="small" />
            </ListItemIcon>
            <ListItemText>Preview</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => viewDownloadFileHandler("Download", fileData)}
          >
            <ListItemIcon>
              <GetApp fontSize="small" />
            </ListItemIcon>
            <ListItemText>Download</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleRenameClick}>
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
          </MenuItem>
          {!isClient && (
            <MenuItem onClick={handleMoveClick}>
              <ListItemIcon>
                <DriveFileMoveOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Move</ListItemText>
            </MenuItem>
          )}
          {canSendForSignature && (
            <MenuItem onClick={handleSendForSignatureClick}>
              <ListItemIcon>
                <DrawOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Send for Signature</ListItemText>
            </MenuItem>
          )}
          {canDeleteDocument && (
            <MenuItem
              onClick={() =>
                handleDeleteFile(
                  fileData,
                  fileData.folder_name,
                  fileData.document_name || fileData.name,
                )
              }
            >
              <ListItemIcon>
                <Delete fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  // Folder action menu component
  const FolderActionMenu = ({ folderData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleRenameClick = () => {
      setSelectedFolder(folderData);
      setNewName(folderData.folder_name);
      setRenameFolderModalOpen(true);
      handleMenuClose();
    };

    const handleDeleteClick = async () => {
      await handleDeleteFolder(folderData);
      handleMenuClose();
    };

    const handleMoveClick = () => {
      openMoveModal("folder", folderData);
      handleMenuClose();
    };

    return (
      <>
        <IconButton onClick={handleMenuClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleRenameClick}>
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
          </MenuItem>
          {!isClient && (
            <MenuItem onClick={handleMoveClick}>
              <ListItemIcon>
                <DriveFileMoveOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText>Move</ListItemText>
            </MenuItem>
          )}
          {canDeleteDocument && (
            <MenuItem onClick={handleDeleteClick}>
              <ListItemIcon>
                <Delete fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </>
    );
  };

  // Render rows for document type
  const renderRowsForType = (type) => {
    const folders = filterRecordsByClientCategory(
      fileStructure.folders.filter((f) => f.folder_type === type),
      docCategory,
    );
    let files = filterRecordsByClientCategory(
      fileStructure.files.filter(
        (f) =>
          (!f.doc_type || f.doc_type === type) &&
          fileBelongsToCurrentFolder(f, navPath),
      ),
      docCategory,
    );

    // Only show not-downloaded documents in the main folder structure list
    // Clients should always see their documents regardless of download status
    if (!isClient) {
      files = files.filter((f) => Number(f.downloaded) !== 1);
    }

    if (!folders.length && !files.length) {
      return (
        <tr>
          <td colSpan={5} className="documents-empty-cell">
            <Empty />
          </td>
        </tr>
      );
    }

    return (
      <>
        {/* ================= FOLDERS ================= */}
        {folders.map((data) => {
          const folderUnread = getFolderUnreadCount(
            data.client_folder_id,
            currentDocTab,
          );
          return (
          <tr
            key={`folder-${data.client_folder_id}`}
            className={`documents-row is-folder${
              folderUnread > 0 ? " is-new-unread" : ""
            }`}
            onClick={() =>
              handleOpen(
                data.folder_name,
                data.client_folder_id,
                data.created_by,
                undefined,
                data.folder_type,
              )
            }
          >
            <td className="doc-name-cell">
              {getFileTypeIcon(null, true)}
              <span>{data.folder_name}</span>
            </td>

            <td>{dateTimeFormatter(data.updatedAt)}</td>
            <td>{formatDocumentCreatedAt(data)}</td>

            <td>{getReadableFileType(null, true)}</td>

            <td
              className="doc-action-cell"
              onClick={(e) => e.stopPropagation()}
            >
              <IconButton
                onClick={() =>
                  bulkDownloadHandler({
                    folder_name: data.folder_name,
                    folder_id: data.client_folder_id,
                  })
                }
              >
                <GetApp fontSize="small" />
              </IconButton>
              <FolderActionMenu folderData={data} />
            </td>
          </tr>
          );
        })}

        {/* ================= FILES ================= */}
        {files.map((data) => {
          const fileIsNew = isFileHighlighted(
            data.client_document_id,
            currentDocTab,
          );
          return (
          <tr
            key={`file-${data.client_document_id}`}
            className={`documents-row${
              fileIsNew ? " is-new-unread" : ""
            }`}
            onClick={() => viewDownloadFileHandler("Preview", data)}
          >
            <td className="doc-name-cell">
              {getFileTypeIcon(normalizeMimeType(data))}
              <div className="doc-name-text">
                <div className="doc-name-primary">{data.document_name}</div>
                {isFiledCopiesDocTab && data.document_tag ? (
                  <div className="doc-name-secondary">{data.document_tag}</div>
                ) : null}
              </div>
            </td>

            <td>{dateTimeFormatter(data.updatedAt)}</td>
            <td>{formatDocumentCreatedAt(data)}</td>

            <td>{getReadableFileType(normalizeMimeType(data))}</td>

            <td
              className="doc-action-cell"
              onClick={(e) => e.stopPropagation()}
            >
              <IconButton
                onClick={() => viewDownloadFileHandler("Download", data)}
              >
                <GetApp fontSize="small" />
              </IconButton>
              <FileActionMenu fileData={data} />
            </td>
          </tr>
          );
        })}
      </>
    );
  };

  // Show/hide buttons based on conditions
  const showClientAddFolder = isClient && docFileType === "sent";

  const isInsideFolder = getKeyPath() !== HOME_FOLDER;

  const showClientUpload = isClient && docFileType === "sent" && isInsideFolder;

  const showEmpAddFolder = isEmployee && docFileType === "sent";

  const showEmpUpload = isEmployee && docFileType === "sent" && isInsideFolder;

  const showStaffReceivedAddFolder = isEmployee && docFileType === "received";

  const showStaffReceivedUpload =
    isEmployee && docFileType === "received" && isInsideFolder;

  const showOfficeAddFolder = isEmployee && docFileType === "office";

  const showOfficeUpload =
    isEmployee && docFileType === "office" && isInsideFolder;

  const showK1PackageAddFolder =
    isEmployee && docFileType === K1_PACKAGE_PURPOSE_TAB;

  const showK1PackageUpload =
    isEmployee &&
    docFileType === K1_PACKAGE_PURPOSE_TAB &&
    isInsideFolder;

  const showIndividualFiledCopiesAddFolder =
    isEmployee && docFileType === FILED_COPIES_PURPOSE_TAB;

  const showIndividualFiledCopiesUpload =
    isEmployee &&
    docFileType === FILED_COPIES_PURPOSE_TAB &&
    isInsideFolder;

  const hasExistingFolder =
    folderModalPath.length > 1 &&
    folderModalPath[folderModalPath.length - 1].name?.toLowerCase() !==
      pendingFolders[0]?.name?.toLowerCase();

  const modalBreadcrumbPath =
    pendingFolders.length > 0
      ? [
          ...(hasExistingFolder ? folderModalPath : navPath),
          ...pendingFolders.map((folder) => ({
            id: folder.name,
            name: folder.name,
          })),
        ]
      : folderModalPath.length > 0
        ? folderModalPath
        : navPath.length > 1
          ? navPath
          : [];

  // ==================== END DOCUMENT HANDLERS ====================

  if (!clientData) {
    return (
      <div className="client-details-loading">
        <p>Loading client details...</p>
      </div>
    );
  }

  const clientName = `${clientData.first_name || ""} ${
    clientData.last_name || ""
  }`.trim();

  // Helper function to get employee name by ID
  const getEmployeeName = (employeeId) => {
    if (!employeeId || !activeEmployees || !activeEmployees.length)
      return "---";
    const employee = activeEmployees.find(
      (emp) => String(emp.employee_id) === String(employeeId),
    );
    return employee
      ? `${employee.first_name || ""} ${employee.last_name || ""}`.trim()
      : "---";
  };

  // Helper function to get country name from ID
  const getCountryName = (countryId) => {
    if (
      !countryId ||
      !master.country ||
      !Array.isArray(master.country) ||
      master.country.length === 0
    ) {
      return "-";
    }
    const country = master.country.find((c) => {
      const cId = c.country_id || c.id;
      return (
        Number(cId) === Number(countryId) || String(cId) === String(countryId)
      );
    });
    return country
      ? country.value ||
          country.country_name ||
          country.name ||
          country.country ||
          "-"
      : "-";
  };

  // Helper function to get state name from ID
  const getStateName = (stateId, isBusiness = false) => {
    const stateList = isBusiness ? master.business_state : master.state;
    if (
      !stateId ||
      !stateList ||
      !Array.isArray(stateList) ||
      stateList.length === 0
    ) {
      return "-";
    }
    const state = stateList.find((s) => {
      const sId = s.state_id || s.id;
      return Number(sId) === Number(stateId) || String(sId) === String(stateId);
    });
    return state
      ? state.value || state.state_name || state.name || state.state || "-"
      : "-";
  };

  const getVisiblePassword = (password) => {
    if (!password) return "";
    try {
      return decryptPassword(password);
    } catch (error) {
      return password;
    }
  };

  const handlePersonalEditClick = () => {
    setPersonalEditedData({
      first_name: clientData.first_name || "",
      last_name: clientData.last_name || "",
      email: clientData.email || "",
      password: getVisiblePassword(clientData.password),
      phone: clientData.phone || "",
      mfa_phone: clientData.mfa_phone || clientData.mfaPhone || "",
      address_1: clientData.address_1 || "",
      address_2: clientData.address_2 || "",
      country_id: clientData.country_id || null,
      state_id: clientData.state_id || null,
      city_id: clientData.city_id || "",
      zipcode: clientData.zipcode || "",
    });
    setIsPersonalEditMode(true);
  };

  const handlePersonalCancelEdit = () => {
    setIsPersonalEditMode(false);
    setPersonalEditedData({});
  };

  const handlePersonalFieldChange = (field, value) => {
    if (field === "email" && !canChangeClientEmail) {
      return;
    }
    setPersonalEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "country_id") {
      setPersonalEditedData((prev) => ({ ...prev, state_id: null }));
      if (value) {
        dispatch(
          MASTER_ACTION.getMasterData({
            name: "state",
            id: value,
          }),
        );
      }
    }
  };

  const handlePersonalSaveEdit = async () => {
    if (!id) return;
    setIsSavingPersonal(true);
    try {
      const normalizeNullableInt = (val) => {
        if (val === "" || val === undefined || val === null) return null;
        return val;
      };

      const payload = {
        ...personalEditedData,
        country_id: normalizeNullableInt(personalEditedData.country_id),
        state_id: normalizeNullableInt(personalEditedData.state_id),
      };

      if (!canChangeClientEmail) {
        delete payload.email;
      }

      if (payload.password) {
        payload.password = encryptPassword(payload.password);
      } else {
        delete payload.password;
      }

      const response = await CLIENT_ACTION.insertUpdateClient({
        params: payload,
        insertUpdateFlag: 1,
        client_id: id,
      });

      if (response?.data) {
        Toaster.success("Client updated successfully!");
        dispatch(getClientById(id))
          .unwrap()
          .then((data) => {
            if (data) setFetchedClient(data);
          })
          .catch(() => {});
        setIsPersonalEditMode(false);
        setPersonalEditedData({});
      } else {
        Toaster.error(response?.data?.message || "Failed to update client");
      }
    } catch (error) {
      Toaster.error("An error occurred while updating client");
    } finally {
      setIsSavingPersonal(false);
    }
  };

  const handleBusinessEditClick = () => {
    setBusinessEditedData({
      business_name: clientData.business_name || "",
      business_type: clientData.business_type || "",
      business_phone: clientData.business_phone || "",
      business_address_1: clientData.business_address_1 || "",
      business_address_2: clientData.business_address_2 || "",
      business_country_id: clientData.business_country_id || null,
      business_state_id: clientData.business_state_id || null,
      business_city_id: clientData.business_city_id || "",
      business_zipcode: clientData.business_zipcode || "",
    });
    setIsBusinessEditMode(true);
  };

  const handleBusinessCancelEdit = () => {
    setIsBusinessEditMode(false);
    setBusinessEditedData({});
  };

  const handleBusinessFieldChange = (field, value) => {
    setBusinessEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "business_country_id") {
      setBusinessEditedData((prev) => ({ ...prev, business_state_id: null }));
      if (value) {
        dispatch(
          MASTER_ACTION.getMasterData({
            name: "state",
            name_type: "business_state",
            id: value,
          }),
        );
      }
    }
  };

  const handleBusinessSaveEdit = async () => {
    if (!id) return;
    setIsSavingBusiness(true);
    try {
      const normalizeNullableInt = (val) => {
        if (val === "" || val === undefined || val === null) return null;
        return val;
      };

      const payload = {
        ...businessEditedData,
        business_country_id: normalizeNullableInt(
          businessEditedData.business_country_id,
        ),
        business_state_id: normalizeNullableInt(
          businessEditedData.business_state_id,
        ),
      };

      const response = await CLIENT_ACTION.insertUpdateClient({
        params: payload,
        insertUpdateFlag: 1,
        client_id: id,
      });

      if (response?.data) {
        Toaster.success("Business details updated successfully!");
        dispatch(getClientById(id))
          .unwrap()
          .then((data) => {
            if (data) setFetchedClient(data);
          })
          .catch(() => {});
        setIsBusinessEditMode(false);
        setBusinessEditedData({});
      } else {
        Toaster.error(
          response?.data?.message || "Failed to update business details",
        );
      }
    } catch (error) {
      Toaster.error("An error occurred while updating business details");
    } finally {
      setIsSavingBusiness(false);
    }
  };

  const renderPersonalEditableField = (field, value, config = {}) => {
    if (!isPersonalEditMode) {
      return value || "-";
    }

    const {
      type = "text",
      dropdown = [],
      disabled = false,
      readOnly = false,
      labelname = "",
    } = config;

    if (type === "phone") {
      const currentValue =
        field in personalEditedData ? personalEditedData[field] : (value ?? "");
      const normalizedValue = currentValue || "+1";

      return (
        <PhoneInput
          labelname={labelname || undefined}
          value={normalizedValue}
          onChange={(val) => {
            const phoneValue =
              val && !val.startsWith("+") ? `+${val}` : val || "";
            handlePersonalFieldChange(field, phoneValue);
          }}
          disabled={disabled}
          placeholder=""
        />
      );
    }

    const isLocked = disabled || readOnly;

    return (
      <Labelbox
        type={type}
        labelname={labelname}
        value={
          field in personalEditedData
            ? personalEditedData[field]
            : (value ?? "")
        }
        changeData={
          isLocked ? undefined : (val) => handlePersonalFieldChange(field, val)
        }
        dropdown={dropdown}
        disabled={disabled}
        readOnly={isLocked}
      />
    );
  };

  const renderBusinessEditableField = (field, value, config = {}) => {
    if (!isBusinessEditMode) {
      return value || "-";
    }

    const {
      type = "text",
      dropdown = [],
      disabled = false,
      labelname = "",
    } = config;

    if (type === "phone") {
      const currentValue =
        field in businessEditedData ? businessEditedData[field] : (value ?? "");
      const normalizedValue = currentValue || "+1";

      return (
        <PhoneInput
          labelname={labelname || undefined}
          value={normalizedValue}
          onChange={(val) => {
            const phoneValue =
              val && !val.startsWith("+") ? `+${val}` : val || "";
            handleBusinessFieldChange(field, phoneValue);
          }}
          disabled={disabled}
          placeholder=""
        />
      );
    }

    return (
      <Labelbox
        type={type}
        labelname={labelname}
        value={
          field in businessEditedData
            ? businessEditedData[field]
            : (value ?? "")
        }
        changeData={(val) => handleBusinessFieldChange(field, val)}
        dropdown={dropdown}
        disabled={disabled}
      />
    );
  };

  const personalInfoData = isPersonalEditMode
    ? {
        name: (
          <div style={{ display: "flex", gap: "8px", width: "100%" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <Labelbox
                type="text"
                labelname="First Name"
                value={personalEditedData.first_name || ""}
                changeData={(val) =>
                  handlePersonalFieldChange("first_name", val)
                }
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <Labelbox
                type="text"
                labelname="Last Name"
                value={personalEditedData.last_name || ""}
                changeData={(val) =>
                  handlePersonalFieldChange("last_name", val)
                }
              />
            </div>
          </div>
        ),
        email: renderPersonalEditableField("email", clientData.email, {
          type: "text",
          readOnly: !canChangeClientEmail,
        }),
        password: renderPersonalEditableField(
          "password",
          clientData.password ? getVisiblePassword(clientData.password) : "",
          { type: "text" },
        ),
        phone: renderPersonalEditableField("phone", clientData.phone, {
          type: "phone",
          labelname: "",
        }),
        mfa_phone: renderPersonalEditableField(
          "mfa_phone",
          clientData.mfa_phone || clientData.mfaPhone,
          {
            type: "phone",
            labelname: "",
          },
        ),
        address_1: renderPersonalEditableField(
          "address_1",
          clientData.address_1,
        ),
        address_2: renderPersonalEditableField(
          "address_2",
          clientData.address_2,
        ),
        country: renderPersonalEditableField(
          "country_id",
          getCountryName(clientData.country_id),
          { type: "select", dropdown: master.country || [] },
        ),
        state: renderPersonalEditableField(
          "state_id",
          getStateName(clientData.state_id),
          { type: "select", dropdown: master.state || [] },
        ),
        city: renderPersonalEditableField("city_id", clientData.city_id),
        zipcode: renderPersonalEditableField("zipcode", clientData.zipcode),
      }
    : {
        name: clientName,
        email: clientData.email || "-",
        password: clientData.password ? "********" : "-",
        phone: clientData.phone || "-",
        mfa_phone: clientData.mfa_phone || clientData.mfaPhone || "-",
        address_1: clientData.address_1 || "-",
        address_2: clientData.address_2 || "-",
        country: getCountryName(clientData.country_id),
        state: getStateName(clientData.state_id),
        city: clientData.city_id || "-",
        zipcode: clientData.zipcode || "-",
      };

  const businessInfoData =
    isBusinessEditMode && clientData?.client_type?.toLowerCase() === "business"
      ? {
          business_name: renderBusinessEditableField(
            "business_name",
            clientData.business_name,
          ),
          business_type: renderBusinessEditableField(
            "business_type",
            clientData.business_type,
            {
              type: "select",
              dropdown: [
                {
                  id: "Sole Proprietorship/DBA",
                  value: "Sole Proprietorship/DBA",
                },
                {
                  id: "Limited Liability Company (LLC)",
                  value: "Limited Liability Company (LLC)",
                },
                { id: "S Corporation", value: "S Corporation" },
                { id: "C Corporation", value: "C Corporation" },
                {
                  id: "Non Profit Organization",
                  value: "Non Profit Organization",
                },
              ],
            },
          ),
          business_phone: renderBusinessEditableField(
            "business_phone",
            clientData.business_phone,
            { type: "phone", labelname: "" },
          ),
          business_address_1: renderBusinessEditableField(
            "business_address_1",
            clientData.business_address_1,
          ),
          business_address_2: renderBusinessEditableField(
            "business_address_2",
            clientData.business_address_2,
          ),
          business_country: renderBusinessEditableField(
            "business_country_id",
            getCountryName(clientData.business_country_id),
            { type: "select", dropdown: master.country || [] },
          ),
          business_state: renderBusinessEditableField(
            "business_state_id",
            getStateName(clientData.business_state_id, true),
            { type: "select", dropdown: master.business_state || [] },
          ),
          business_city: renderBusinessEditableField(
            "business_city_id",
            clientData.business_city_id,
          ),
          business_zipcode: renderBusinessEditableField(
            "business_zipcode",
            clientData.business_zipcode,
          ),
        }
      : {
          business_name: clientData.business_name || "-",
          business_type: clientData.business_type || "-",
          business_phone: clientData.business_phone || "-",
          business_address_1: clientData.business_address_1 || "-",
          business_address_2: clientData.business_address_2 || "-",
          business_country: getCountryName(clientData.business_country_id),
          business_state: getStateName(clientData.business_state_id, true),
          business_city: clientData.business_city_id || "-",
          business_zipcode: clientData.business_zipcode || "-",
        };
  const isRootDocumentsFolder = navPath.length === 1 && navPath[0]?.id === 0;
  const addFolderActionText = isRootDocumentsFolder
    ? "Upload Files"
    : "Add Sub Folder";
  const folderModalHeading = (() => {
    if (folderModalStage === "inner") {
      return "Add A Sub Folder";
    }

    if (folderModalStage === "upload") {
      return "Upload Files";
    }

    if (folderModalStage === "menu") {
      return "Upload Files Or Add Sub Folder";
    }

    return "Add A New Folder";
  })();

  return (
    <div
      className={`client-details-wrapper${
        activeTab === "messages" ? " client-details-wrapper--messages-tab" : ""
      }`}
    >
      {/* Breadcrumb */}
      <div className="client-details-breadcrumb">
        {isClient ? (
          <>
            <span
              className="breadcrumb-link"
              onClick={() => navigate(getRolePath("/dashboard"))}
            >
              Dashboard
            </span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-current">
              {activeTab === "taxStrategy" ? "Tax Planning" : "Messages"}
            </span>
          </>
        ) : (
          <>
            <span
              className="breadcrumb-link"
              onClick={() => navigate(getRolePath("/client"))}
            >
              Home
            </span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-current">{clientName}</span>
          </>
        )}
      </div>

      {/* Category switch: Individual / Business */}
      {showClientDetailsCategoryTabs && (
        <div className="client-details-category-switch">
          <div
            className="client-details-category-tabs"
            role="tablist"
            aria-label="Client category"
          >
            <button
              type="button"
              role="tab"
              aria-selected={categoryTab === "individual"}
              className={`client-details-category-tab ${
                categoryTab === "individual" ? "is-active" : ""
              }`}
              onClick={() => {
                if (categoryTab === "individual") return;
                setCategoryTab("individual");
                if (activeTab === "documents") {
                  setNavPath(DOCUMENTS_HOME_NAV);
                  setCurrentIndex(0);
                  setFiletype("home");
                }
              }}
            >
              Individual
            </button>
            {isBusinessClient && (
              <button
                type="button"
                role="tab"
                aria-selected={categoryTab === "business"}
                className={`client-details-category-tab ${
                  categoryTab === "business" ? "is-active" : ""
                }`}
                onClick={() => {
                  if (categoryTab === "business") return;
                  setCategoryTab("business");
                  if (activeTab === "documents") {
                    setNavPath(DOCUMENTS_HOME_NAV);
                    setCurrentIndex(0);
                    setFiletype("home");
                  }
                }}
              >
                Business
              </button>
            )}
          </div>
        </div>
      )}

      {/* Main Content Card */}
      <div className="client-details-card">
        {/* Sub-tabs */}
        <div className="client-details-tabs">
          {(isClient ? CLIENT_SELF_SUB_TABS : staffSubTabs).map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`client-details-tab ${
                activeTab === tab.id ? "is-active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="client-details-content">
          {/* Profile (personal or business details by category) */}
          {activeTab === "profile" && categoryTab === "individual" && (
            <div className="client-details-personal">
              {canEditClient && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                    marginBottom: "12px",
                  }}
                >
                  {!isPersonalEditMode ? (
                    <Button
                      text="Edit"
                      icon={<Edit />}
                      handleClick={handlePersonalEditClick}
                    />
                  ) : (
                    <>
                      <Button
                        text={isSavingPersonal ? "Saving..." : "Save"}
                        icon={<SaveIcon />}
                        handleClick={handlePersonalSaveEdit}
                        disable={isSavingPersonal}
                      />
                      <Button
                        text="Cancel"
                        icon={<CloseIcon />}
                        handleClick={handlePersonalCancelEdit}
                        disable={isSavingPersonal}
                        ui="transparent"
                        variant="outline"
                      />
                    </>
                  )}
                </div>
              )}
              <Paper className="personal-details-card">
                <InfoTable
                  transparent
                  titles={[
                    "Name:",
                    "Email ID:",
                    "Password:",
                    "Phone:",
                    "MFA Phone:",
                    "Address 1:",
                    // "Address 2:",
                    "City:",
                    "State:",
                    "Zip Code:",
                    "Country:",
                  ]}
                  keys={[
                    "name",
                    "email",
                    "password",
                    "phone",
                    "mfa_phone",
                    "address_1",
                    // "address_2",
                    "city",
                    "state",
                    "zipcode",
                    "country",
                  ]}
                  info={personalInfoData}
                />
              </Paper>
            </div>
          )}

          {/* Business Details Tab */}
          {activeTab === "profile" && categoryTab === "business" && isBusinessClient && (
            <div className="client-details-business">
              <ClientBusinessManager
                clientId={id}
                clientRecord={clientData}
                canEdit={canManageClientBusinesses}
                allowDelete={canDeleteClientBusiness}
                onClientUpdated={(updated) => {
                  setFetchedClient(updated);
                  if (isClient) {
                    syncBusinessAccess(updated);
                  }
                }}
              />
            </div>
          )}

          {/* Invoices Tab */}
          {activeTab === "invoices" && (
            <div className="client-details-invoices">
              {!isClient && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "12px",
                    gap: "8px",
                  }}
                >
                  <Button
                    text="Create Invoice"
                    handleClick={handleCreateInvoice}
                  />
                </div>
              )}
              <Table
                title=""
                header={invoiceHeader}
                data={invoiceTableData}
                EnableSno={false}
                actions={["edit", "paymentStatus"]}
                menuActions={["print", "email", "delete", "pay"]}
                onActionClick={handleInvoiceAction}
                restrictActionIcon
                aligncss="dashboard-table"
                className="client-invoices-table"
                icons={{ eyeIcon: true }}
                hiddenFields={[
                  "_rowClass",
                  "_rowStyle",
                  "_invoiceData",
                  "enabledActions",
                ]}
              />

              {showClientPaymentDetails && (
                <div style={{ marginTop: "16px" }}>
                  <ContractPayment
                    userId={id}
                    USER_DATA={clientData}
                    fetchAll={true}
                  />
                </div>
              )}
            </div>
          )}

          {/* Documents Tab (Individual / Business) */}
          {isDocumentsTab && (
            <div
              className={`client-details-documents${
                hasDocumentPreviews ? " documents-with-preview-dock" : ""
              }`}
            >
              {showBusinessSelector && (
                <ClientBusinessSelector
                  businesses={clientBusinesses}
                  value={selectedClientBusinessId}
                  onChange={(nextBusinessId) => {
                    setSelectedClientBusinessId(nextBusinessId);
                  }}
                />
              )}
              <div className="documents-toolbar-bar">
                <div className="document-type-tabs">
                  <div className="document-type-tabs-left">
                    <button
                      className={`document-type-tab ${
                        docFileType === "received" ? "is-active" : ""
                      }`}
                      onClick={() => handleDocFileTypeChange("received")}
                    >
                      {isClient ? "Files from FinloTax" : "Client Uploads"}
                      <DocumentTabBadge count={documentTabUnread.received} />
                    </button>
                    <button
                      className={`document-type-tab ${
                        docFileType === "sent" ? "is-active" : ""
                      }`}
                      onClick={() => handleDocFileTypeChange("sent")}
                    >
                      {isClient ? "My Uploads" : "FinloTax Uploads"}
                      <DocumentTabBadge count={documentTabUnread.sent} />
                    </button>
                    {!isClient && (
                      <button
                        className={`document-type-tab ${
                          docFileType === "office" ? "is-active" : ""
                        }`}
                        onClick={() => handleDocFileTypeChange("office")}
                      >
                        Internal Files
                        <DocumentTabBadge count={documentTabUnread.office} />
                      </button>
                    )}
                    {!isClient && (
                      <button
                        className={`document-type-tab ${
                          docFileType === "requested" ? "is-active" : ""
                        }`}
                        onClick={() => handleDocFileTypeChange("requested")}
                      >
                        Documents Requested
                        <DocumentTabBadge count={documentTabUnread.requested} />
                      </button>
                    )}
                    {isClient && (
                      <button
                        className={`document-type-tab ${
                          docFileType === "requested" ? "is-active" : ""
                        }`}
                        onClick={() => handleDocFileTypeChange("requested")}
                      >
                        Pending Files
                        <DocumentTabBadge count={documentTabUnread.requested} />
                      </button>
                    )}
                    <button
                      className={`document-type-tab ${
                        docFileType === DOC_TAB_SENT_FOR_SIGNATURE
                          ? "is-active"
                          : ""
                      }`}
                      onClick={() =>
                        handleDocFileTypeChange(DOC_TAB_SENT_FOR_SIGNATURE)
                      }
                    >
                      {isClient ? "Files for Signature" : "Sent for Signature"}
                    </button>
                    {!isBusinessDocCategory && (
                      <button
                        className={`document-type-tab ${
                          docFileType === FILED_COPIES_PURPOSE_TAB
                            ? "is-active"
                            : ""
                        }`}
                        onClick={() =>
                          handleDocFileTypeChange(FILED_COPIES_PURPOSE_TAB)
                        }
                      >
                        {K1_PACKAGE_TAB_LABEL}
                        <DocumentTabBadge
                          count={documentTabUnread[FILED_COPIES_PURPOSE_TAB]}
                        />
                      </button>
                    )}
                    {!isClient && isBusinessDocCategory && (
                      <button
                        className={`document-type-tab ${
                          docFileType === K1_PACKAGE_PURPOSE_TAB ? "is-active" : ""
                        }`}
                        onClick={() =>
                          handleDocFileTypeChange(K1_PACKAGE_PURPOSE_TAB)
                        }
                      >
                        {K1_PACKAGE_TAB_LABEL}
                        <DocumentTabBadge
                          count={documentTabUnread[K1_PACKAGE_PURPOSE_TAB]}
                        />
                      </button>
                    )}
                  </div>

                  <div className="document-type-tabs-actions">
                    {docFileType === "sent" && (
                      <>
                        {isClient && showClientAddFolder && isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="clientaddfolder"
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("emp_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {isClient && showClientUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              className="clientupload"
                              variant="outline"
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload Files"
                              handleClick={() => setModalOpen("emp_upload")}
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {isEmployee && showEmpAddFolder && isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="empaddfolder"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("emp_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {isEmployee && showEmpUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="empuploaddoc"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload Files"
                              handleClick={openStaffUploadModal}
                            />
                          </UploadFilesHelpTooltip>
                        )}
                      </>
                    )}

                    {docFileType === "received" && isEmployee && (
                      <>
                        {showStaffReceivedAddFolder && isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="empaddfolder"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("emp_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {showStaffReceivedUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="empuploaddoc"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload Files"
                              handleClick={openStaffUploadModal}
                            />
                          </UploadFilesHelpTooltip>
                        )}
                      </>
                    )}

                    {docFileType === "office" && (
                      <>
                        {showOfficeAddFolder && isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="officeaddfolder"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("office_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {showOfficeUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="officedoc"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload"
                              handleClick={() => setModalOpen("office_upload")}
                            />
                          </UploadFilesHelpTooltip>
                        )}
                      </>
                    )}

                    {docFileType === K1_PACKAGE_PURPOSE_TAB && (
                      <>
                        {showK1PackageAddFolder && isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="k1packageaddfolder"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("k1_package_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {showK1PackageUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="k1packageupload"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload"
                              handleClick={() => setModalOpen("k1_package_upload")}
                            />
                          </UploadFilesHelpTooltip>
                        )}
                      </>
                    )}

                    {docFileType === FILED_COPIES_PURPOSE_TAB && (
                      <>
                        {showIndividualFiledCopiesAddFolder &&
                          isRootDocumentsFolder && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="filedcopiesaddfolder"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={AddFolder} alt="Add folder" />}
                              text={addFolderActionText}
                              handleClick={() =>
                                openPageAddFolder("filed_copies_add_folder")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                        {showIndividualFiledCopiesUpload && (
                          <UploadFilesHelpTooltip>
                            <Button
                              variant="outline"
                              className="filedcopiesupload"
                              disable={!HOME_USER_ID}
                              iconCls="btn_icon"
                              icon={<img src={FileUpload} alt="File upload" />}
                              text="Upload"
                              handleClick={() =>
                                setModalOpen("filed_copies_upload")
                              }
                            />
                          </UploadFilesHelpTooltip>
                        )}
                      </>
                    )}

                    {docFileType === "requested" && isEmployee && (
                    <RequestedFilesBlock
                      clientId={id}
                      layoutMode="buttonOnly"
                      requestedFileCategory={docCategory}
                      clientBusinessId={selectedClientBusinessId}
                        onRequestSuccess={() =>
                          setRequestedFilesRefreshKey((k) => k + 1)
                        }
                      />
                    )}
                  </div>
                </div>

                {docFileType === "requested" && isEmployee && (
                  <div className="requested-files-table-section">
                    <RequestedFilesBlock
                      clientId={id}
                      layoutMode="tableOnly"
                      refreshKey={requestedFilesRefreshKey}
                      requestedFileCategory={docCategory}
                      clientBusinessId={selectedClientBusinessId}
                    />
                  </div>
                )}

                {docFileType === DOC_TAB_SENT_FOR_SIGNATURE && (
                  <div className="client-details-signature documents-signature-section">
                    <DocuSignSignaturePanel
                      clientId={id}
                      documentCategory={categoryTab}
                      clientBusinessId={selectedClientBusinessId}
                      readOnly={isClient}
                      refreshKey={signatureRefreshKey}
                      showAdminTools={isAdmin}
                    />
                  </div>
                )}

                {isDocumentsFolderTab(docFileType) && (
                  <>
                    {/* Breadcrumbs */}
                    <div className="documents-breadcrumb-row">
                      {navPath?.map((item, index) => (
                        <React.Fragment key={`crumb-${index}`}>
                          {index > 0 && (
                            <span className="documents-location-separator">
                              ›
                            </span>
                          )}
                          <span
                            className={
                              "documents-location-item" +
                              (index === navPath.length - 1
                                ? " current-folder"
                                : "")
                            }
                            onClick={() =>
                              handleOpen(
                                item.name,
                                item.id,
                                item.created_by,
                                index,
                              )
                            }
                          >
                            {index === 0 ? getActiveTabLabel(docFileType) : item.name}
                          </span>
                        </React.Fragment>
                      ))}
                    </div>

                    {/* Table */}
                    <div className="documents-table-wrapper">
                      <table className="documents-table">
                        <thead>
                          <tr>
                            <th style={{ width: "38%" }}>Document</th>
                            <th style={{ width: "14%" }}>Date</th>
                            <th style={{ width: "14%" }}>Created At</th>
                            <th style={{ width: "14%" }}>File Type</th>
                            <th style={{ width: "10%", textAlign: "right" }}>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {docFileType === "sent" && renderRowsForType("emp")}
                          {docFileType === "received" &&
                            renderRowsForType("client")}
                          {docFileType === "office" &&
                            renderRowsForType("office")}
                          {docFileType === K1_PACKAGE_PURPOSE_TAB &&
                            renderRowsForType(DOC_TYPE_K1_PACKAGE)}
                          {docFileType === FILED_COPIES_PURPOSE_TAB &&
                            renderRowsForType(DOC_TYPE_FILED_COPIES)}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* Downloaded section (API-driven: folder.downloaded / file.downloaded) */}
                {renderDownloadedSection()}
              </div>
            </div>
          )}

          {/* Notification Tab */}
          {activeTab === "notification" && (
            <div className="client-details-notification">
              <Table
                title=""
                header={notificationHeader}
                data={notificationTableData}
                initialRowsPerPage={10}
                EnableSno={false}
                aligncss="dashboard-table"
                className="client-notification-table"
                hiddenFields={[
                  "_rowClass",
                  "_rowStyle",
                  "_notificationData",
                  "viewed",
                ]}
                onRowClick={(row) => {
                  if (row._notificationData) {
                    handleNotificationClick(row._notificationData);
                  }
                }}
              />
            </div>
          )}

          {/* Comments Tab */}
          {activeTab === "comments" && (
            <div className="client-details-comments">
              <Paper className="comments-card">
                <div
                  className="reports-date-range"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                    marginBottom: 16,
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ minWidth: "200px" }}>
                    <Labelbox
                      type="select"
                      labelname="Date Range"
                      value={
                        commentDateFilter.range === "Custom"
                          ? "Custom"
                          : commentDateFilter.range || DEFAULT_DATE_RANGE_PRESET
                      }
                      dropdown={commentDateRanges.map((range) => ({
                        id: range,
                        value: range,
                      }))}
                      changeData={(range) => {
                        if (range === "Custom") {
                          setCommentDateFilter((p) => ({
                            ...p,
                            range: "Custom",
                          }));
                          return;
                        }
                        const { start_date, end_date } = getDateRange(range);
                        setCommentDateFilter({
                          range,
                          start_date,
                          end_date,
                        });
                      }}
                    />
                  </div>

                  <Labelbox
                    type="datepicker"
                    labelname="Start Date"
                    value={commentDateFilter.start_date || ""}
                    changeData={(e) =>
                      setCommentDateFilter((p) => ({
                        ...p,
                        range: "Custom",
                        start_date: e,
                      }))
                    }
                  />

                  <Labelbox
                    type="datepicker"
                    labelname="End Date"
                    value={commentDateFilter.end_date || ""}
                    changeData={(e) =>
                      setCommentDateFilter((p) => ({
                        ...p,
                        range: "Custom",
                        end_date: e,
                      }))
                    }
                  />
                </div>

                <div className="comments-input-section">
                  <textarea
                    className="comments-textarea"
                    placeholder="Type your comment here..."
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    rows={6}
                    disabled={isSubmittingComment}
                  />
                  <div className="comments-actions">
                    <Button
                      text={isSubmittingComment ? "Adding..." : "Add Notes"}
                      handleClick={async () => {
                        if (!commentText.trim()) {
                          Toaster.warning("Please enter a comment");
                          return;
                        }

                        if (!id) {
                          Toaster.error("Client ID not found");
                          return;
                        }

                        setIsSubmittingComment(true);
                        try {
                          const payload = commentText
                            .replace(/\r\n/g, "\n")
                            .trim();
                          const result =
                            await CLIENT_ACTION.createClientComment({
                              client_id: id,
                              comment: payload,
                              category: categoryTab,
                            });

                          if (result?.data?.status === 1) {
                            Toaster.success("Comment added successfully");
                            setCommentText("");
                            // Refresh comments list
                            const commentsData = await dispatch(
                              CLIENT_ACTION.getClientComments({
                                clientId: id,
                                start_date: commentDateFilter.start_date,
                                end_date: commentDateFilter.end_date,
                                category: categoryTab,
                              }),
                            ).unwrap();
                            setCommentsList(commentsData || []);
                          } else {
                            Toaster.error(
                              result?.data?.message || "Failed to add comment",
                            );
                          }
                        } catch (error) {
                          Toaster.error(
                            "Error adding comment. Please try again.",
                          );
                        } finally {
                          setIsSubmittingComment(false);
                        }
                      }}
                      large
                      disable={isSubmittingComment}
                    />
                  </div>
                </div>

                {filteredCommentsList.length > 0 && (
                  <div className="comments-list">
                    <h4 className="comments-list-title">Previous Notes</h4>
                    {filteredCommentsList.map((comment) => {
                      // Get employee name from activeEmployees if available
                      const employeeName =
                        comment.employee_id && activeEmployees?.length > 0
                          ? (() => {
                              const emp = activeEmployees.find(
                                (e) => e.employee_id === comment.employee_id,
                              );
                              return emp
                                ? `${emp.first_name || ""} ${
                                    emp.last_name || ""
                                  }`.trim()
                                : "Employee";
                            })()
                          : comment.employee_name || "Employee";

                      const currentUserId = localStorage.getItem("user_id");
                      const currentUserRole = localStorage.getItem("user_role");
                      const commentId = comment.comment_id || comment.id;
                      const canDelete =
                        isEmployee &&
                        (currentUserRole === "admin" ||
                          comment.created_by === currentUserId);
                      const canEdit = canDelete;

                      return (
                        <div key={commentId} className="comment-item">
                          <div className="comment-header">
                            <div
                              style={{ display: "flex" }}
                              className="comment-author-info"
                            >
                              <span className="comment-author">
                                {employeeName} :
                              </span>
                              <span className="comment-text">
                                {comment.comment || comment.text}
                              </span>
                            </div>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {" "}
                              <span className="comment-date">
                                {dateTimeFormatter(
                                  comment.createdAt || comment.date,
                                )}
                              </span>
                              {canEdit && (
                                <IconButton
                                  onClick={() =>
                                    setEditCommentModal({
                                      open: true,
                                      commentId,
                                      text: String(
                                        comment.comment || comment.text || "",
                                      ),
                                    })
                                  }
                                  size="small"
                                >
                                  <Edit fontSize="small" />
                                </IconButton>
                              )}
                              {canDelete && (
                                <IconButton
                                  onClick={() => handleDeleteComment(comment)}
                                  size="small"
                                >
                                  <Delete fontSize="small" color="error" />
                                </IconButton>
                              )}
                            </div>
                          </div>
                          {/* <p className="comment-text">
                            {comment.comment || comment.text}
                          </p> */}
                        </div>
                      );
                    })}
                  </div>
                )}

                {filteredCommentsList.length === 0 && (
                  <div className="comments-empty">
                    <Empty description="No comments yet" />
                  </div>
                )}
              </Paper>
            </div>
          )}

          {editCommentModal.open && (
            <Modal
              open={editCommentModal.open}
              className="edit-note-modal timesheet-view-modal"
              handleClose={() =>
                isUpdatingComment
                  ? null
                  : setEditCommentModal({
                      open: false,
                      commentId: null,
                      text: "",
                    })
              }
              maxWidth
              title={null}
            >
              <div className="edit-note-wrapper">
                <div className="edit-note-header">
                  <h2 className="edit-note-title">Edit note</h2>
                  <IconButton
                    className="edit-note-close-btn"
                    onClick={() =>
                      isUpdatingComment
                        ? null
                        : setEditCommentModal({
                            open: false,
                            commentId: null,
                            text: "",
                          })
                    }
                    size="small"
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>

                <div
                  className="comments-input-section"
                  style={{ marginBottom: 0 }}
                >
                  <textarea
                    className="comments-textarea"
                    placeholder="Update your note..."
                    value={editCommentModal.text}
                    onChange={(e) =>
                      setEditCommentModal((p) => ({
                        ...p,
                        text: e.target.value,
                      }))
                    }
                    rows={6}
                    disabled={isUpdatingComment}
                  />
                  <div
                    className="comments-actions"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <Button
                      text={isUpdatingComment ? "Saving..." : "Save"}
                      disable={isUpdatingComment}
                      handleClick={async () => {
                        const nextText = String(editCommentModal.text || "")
                          .replace(/\r\n/g, "\n")
                          .trim();
                        if (!nextText) {
                          Toaster.warning("Please enter a comment");
                          return;
                        }
                        if (!editCommentModal.commentId) {
                          Toaster.error("Comment ID not found");
                          return;
                        }
                        setIsUpdatingComment(true);
                        try {
                          const result =
                            await CLIENT_ACTION.updateClientComment({
                              comment_id: editCommentModal.commentId,
                              comment: nextText,
                            });
                          if (result?.data?.status === 1) {
                            Toaster.success("Comment updated successfully");
                            setEditCommentModal({
                              open: false,
                              commentId: null,
                              text: "",
                            });
                            const commentsData = await dispatch(
                              CLIENT_ACTION.getClientComments({
                                clientId: id,
                                start_date: commentDateFilter.start_date,
                                end_date: commentDateFilter.end_date,
                                category: categoryTab,
                              }),
                            ).unwrap();
                            setCommentsList(commentsData || []);
                          } else {
                            Toaster.error(
                              result?.data?.message ||
                                "Failed to update comment",
                            );
                          }
                        } catch (error) {
                          Toaster.error(
                            "Error updating comment. Please try again.",
                          );
                        } finally {
                          setIsUpdatingComment(false);
                        }
                      }}
                      large
                    />
                    <Button
                      text="Cancel"
                      variant="outline"
                      ui="transparent"
                      disable={isUpdatingComment}
                      handleClick={() =>
                        setEditCommentModal({
                          open: false,
                          commentId: null,
                          text: "",
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {/* Messages Tab */}
          {activeTab === "messages" && (
            <div className="client-details-messages">
              <Paper className="messages-card">
                <div className="messages-list" ref={messagesListRef}>
                  <div className="message-thread">
                    {displayMessages?.length ? (
                      displayMessages.map((m) => (
                        <MessageChatRow
                          key={m?.message_id || `${m?.createdAt}-${m?.message}`}
                          message={m}
                          loggedInUserId={loggedInUserId}
                          formatDate={(msg) => {
                            const d = formatMessageDate(msg?.createdAt);
                            return d ? `${d},` : "";
                          }}
                          formatTime={(msg) =>
                            msg?.createdAt ? formatTime(msg.createdAt) : ""
                          }
                          onEdit={startEditMessage}
                        />
                      ))
                    ) : (
                      <div className="messages-empty">
                        <Empty description="No messages yet" />
                      </div>
                    )}
                  </div>
                </div>

                <MessageChatInput
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  onSend={sendOrSaveMessage}
                  sending={isSendingMessage}
                  editing={Boolean(editingMessageId)}
                  onCancelEdit={cancelEditMessage}
                />
              </Paper>
            </div>
          )}

          {/* e-filing Tab */}
          {activeTab === "e-filing" && clientData && (
            <EfilingSection
              clientId={id}
              clientData={clientData}
              activeEmployees={activeEmployees}
              loggedInUserId={loggedInUserId}
              clientInvoices={clientInvoices}
              ensureClientInvoices={ensureClientInvoicesForEfiling}
              category={categoryTab}
              onViewInvoice={async (invoice) => {
                if (!invoice) return;
                const detail = await loadInvoiceDocumentData(invoice);
                setDocumentContent({
                  state: true,
                  data: detail,
                });
              }}
            />
          )}

          {activeTab === "taxStrategy" && clientData && (
            <TaxStrategySection
              clientId={id}
              clientData={clientData}
              activeEmployees={activeEmployees}
              loggedInUserId={loggedInUserId}
              userRole={userRole}
              category={categoryTab}
            />
          )}

          {!isClient && activeTab === "services" && id && (
            <ClientServicesSection
              clientId={id}
              category={categoryTab}
              initialStatusTab={location?.state?.service_status_tab}
              initialEditingServiceId={
                location?.state?.editing_service_id
              }
            />
          )}
        </div>
      </div>

      {/* Upload / add folder modal */}
      {isModalOpen && (
        <Modal
          className={`timesheet-view-modal ${
            isModalOpen.includes("upload") ? "upload-files-modal" : ""
          } ${
            isModalOpen.includes("add_folder") &&
            !isModalOpen.includes("upload")
              ? "add-folder-modal"
              : ""
          }`}
          open={isModalOpen}
          handleClose={handleCloseModal}
          maxWidth={false}
          // className={isModalOpen.includes("upload") ? "upload-files-modal" : ""}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div>
              <h3 style={{ fontWeight: "bold", fontSize: "24px" }}>
                {isModalOpen.includes("upload")
                  ? "Upload Files"
                  : folderModalHeading}
              </h3>
              {modalBreadcrumbPath.length > 0 && (
                <div
                  style={{
                    color: "#6b7280",
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginTop: "4px",
                  }}
                >
                  {modalBreadcrumbPath.map((part, index) => (
                    <React.Fragment key={`modal-breadcrumb-${index}`}>
                      {index > 0 && <span> &gt; </span>}
                      <span>{part.name}</span>
                    </React.Fragment>
                  ))}
                </div>
              )}
              {isModalOpen.includes("upload") && showUploadSubFolderInput && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="text"
                    value={uploadSubFolderName}
                    onChange={(e) => setUploadSubFolderName(e.target.value)}
                    placeholder="Enter sub folder name"
                    style={{
                      minWidth: "260px",
                      height: "40px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "0 12px",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  />
                  <button
                    className="upload-button"
                    onClick={addUploadSubFolder}
                  >
                    Add
                  </button>
                  <button
                    className="upload-button"
                    onClick={cancelUploadSubFolderInput}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <button className="close-btn" onClick={handleCloseModal}>
              ✕
            </button>
          </div>
          <div className="add_folder_modal">
            {isModalOpen.includes("upload") ? (
              <>
                <div className="upload-modal">
                  <div
                    className="drop-area-main"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <p className="drop-text">Drag & Drop file here, or</p>
                    <p className="upload-file-note">
                      {DOCUMENT_UPLOAD_SIZE_NOTE}
                    </p>
                    <label className="file-input-label">
                      <input
                        type="file"
                        multiple
                        accept={DOCUMENT_UPLOAD_ACCEPT}
                        onChange={handleFileChange}
                        hidden
                      />
                      <span className="add-files-button">Add Files</span>
                    </label>
                  </div>

                  {showFiledCopiesTagPicker ? (
                      <FiledCopiesUploadFileList
                        files={selectedFiles}
                        tags={filedCopiesFileTags}
                        documentCategory={docCategory}
                        serviceOptions={filedCopiesServiceOptions}
                        selectedServiceId={filedCopiesSelectedServiceId}
                        onServiceChange={setFiledCopiesSelectedServiceId}
                        onTagChange={handleFiledCopiesTagChange}
                        onRemoveFile={handleRemoveFile}
                      />
                    ) : selectedFiles.length > 0 ? (
                    <div className="individual-file-fields">
                      {selectedFiles.map((file, index) => (
                        <div key={index} className="individual-file-field">
                          <div className="file-field-content">
                            <span className="file-name-text">{file.name}</span>
                            <button
                              className="remove-file-icon"
                              onClick={() => handleRemoveFile(index)}
                              aria-label="Remove file"
                            >
                              ✖
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    ) : null}

                  <div className="upload-modal-footer">
                    <div className="email-switch">
                      <EmailNotificationSwitch
                        checked={sendNotifications}
                        onChange={handleEmailNotificationChange}
                      />
                    </div>
                    <div className="upload-modal-actions">
                      {(modalBreadcrumbPath.length > 1) &&
                        !showUploadSubFolderInput && (
                          <button
                            className="upload-button"
                            onClick={openUploadSubFolderInput}
                          >
                            Add Sub Folder
                          </button>
                        )}
                      <button
                        className="upload-button"
                        onClick={() => modelAction()}
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: "100%",
                    marginTop: "7px",
                    marginBottom: "16px",
                  }}
                >
                  {folderModalStage === "root" &&
                  navPath.length === 1 &&
                  navPath[0]?.id === 0 ? (
                    <Labelbox
                      type="select"
                      labelname="Folder Name"
                      dropdown={rootUploadFolderOptions}
                      changeData={(data) => setNewFolderName(data)}
                      value={newFolderName}
                    />
                  ) : folderModalStage === "inner" ? (
                    <Labelbox
                      type="text"
                      changeData={(data) =>
                        setNewFolderName(data.replace(/[^\w ]/g, ""))
                      }
                      value={newFolderName}
                      placeholder="Enter name"
                    />
                  ) : null}
                </div>

                <div className="modal-actions-right">
                  {folderModalStage === "root" &&
                    navPath.length === 1 &&
                    navPath[0]?.id === 0 && (
                      <>
                        {!folderExists && (
                          <button
                            className="upload-button"
                            onClick={handleCreateFolderDirectly}
                          >
                            Add
                          </button>
                        )}
                        <button
                          className="upload-button"
                          style={{ marginLeft: folderExists ? "0px" : "8px" }}
                          onClick={() => modelAction()}
                        >
                          Upload Files
                        </button>
                      </>
                    )}

                  {folderModalStage === "menu" && (
                    <>
                      <button
                        className="upload-button"
                        onClick={openFolderModalUpload}
                      >
                        Upload Files
                      </button>
                      {/* <button
                        className="upload-button"
                        onClick={openInnerFolderModal}
                        style={{ marginLeft: "8px" }}
                      >
                        Add Sub Folder
                      </button> */}
                    </>
                  )}

                  {folderModalStage === "inner" && (
                    <>
                      <button
                        className="upload-button"
                        onClick={() => modelAction()}
                      >
                        Add
                      </button>
                      {/* <button
                        className="upload-button"
                        style={{ marginLeft: "8px" }}
                        onClick={handleFolderModalBack}
                      >
                        Cancel
                      </button> */}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </Modal>
      )}

      <MultiDocumentPreviewDock
        previews={documentPreviews}
        onRemove={removeDocumentPreview}
        onCloseAll={closeAllDocumentPreviews}
      />

      {/* Rename file dialog */}
      <Dialog
        open={renameModalOpen}
        onClose={() => setRenameModalOpen(false)}
        classes={{ paper: "rename-modal-paper" }}
      >
        <div className="rename-modal">
          <div className="rename-modal-header">
            <h2 className="rename-modal-title">
              {selectedFile !== null
                ? `Rename ${selectedFile.document_name}`
                : "Rename File"}
            </h2>
            <button
              type="button"
              className="rename-modal-close"
              onClick={() => setRenameModalOpen(false)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
          <TextField
            label="New Name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
          />
          <div className="modal-actions-right">
            <button
              className="primary-action-btn"
              onClick={() => handleRenameFile(selectedFile, newName)}
            >
              Rename
            </button>
          </div>
        </div>
      </Dialog>

      {/* Move file/folder modal */}
      <MoveItemModal
        open={moveModalOpen}
        onClose={closeMoveModal}
        item={moveItem}
        userId={id}
        homeFolder={CLIENT_S3_ROOT}
        clientBusinessId={
          isBusinessDocCategory ? selectedClientBusinessId : null
        }
        lockBusinessCategory={isBusinessDocCategory}
        initialDocumentCategory={docCategory}
        initialPurposeTab={
          isFiledCopiesDocTab
            ? docFileType
            : docFileType === "office"
              ? "office"
              : docFileType === "received"
                ? "received"
                : "sent"
        }
        showBusinessTab={isBusinessClient}
        currentFolderId={
          moveItem?.type === "folder"
            ? (moveItem?.data?.parent_folder_id ?? null)
            : (moveItem?.data?.client_folder_id ?? null)
        }
        onConfirm={handleMoveConfirm}
      />

      {/* Rename folder dialog */}
      <Dialog
        open={renameFolderModalOpen}
        onClose={() => setRenameFolderModalOpen(false)}
        classes={{ paper: "rename-modal-paper" }}
      >
        <div className="rename-modal">
          <div className="rename-modal-header">
            <h2 className="rename-modal-title">
              Rename {selectedFolder ? selectedFolder.folder_name : "Folder"}
            </h2>
            <button
              type="button"
              className="rename-modal-close"
              onClick={() => setRenameFolderModalOpen(false)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
          <TextField
            label="New Name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
          />
          <div className="modal-actions-right">
            <button
              className="primary-action-btn"
              onClick={() => handleRenameFolder(selectedFolder, newName)}
            >
              Rename
            </button>
          </div>
        </div>
      </Dialog>

      {/* Delete file confirmation modal */}
      {deleteDialog.open && (
        <Modal
          title={null}
          open={deleteDialog.open}
          handleClose={closeDeleteDialog}
          className="delete-confirm-modal timesheet-view-modal"
        >
          <div className="delete-confirm">
            <div className="delete-confirm-header">
              <h3>Delete</h3>
              <button
                type="button"
                className="delete-confirm-close"
                onClick={closeDeleteDialog}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <p className="delete-confirm-text">Are you sure want delete?</p>
            <div className="delete-confirm-actions">
              <button
                type="button"
                className="delete-btn secondary"
                onClick={closeDeleteDialog}
              >
                No
              </button>
              <button
                type="button"
                className="delete-btn danger"
                onClick={confirmDeleteFile}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete folder confirmation modal */}
      {deleteFolderDialog.open && (
        <Modal
          title={null}
          open={deleteFolderDialog.open}
          handleClose={closeDeleteFolderDialog}
          className="delete-confirm-modal timesheet-view-modal"
        >
          <div className="delete-confirm">
            <div className="delete-confirm-header">
              <h3>Delete</h3>
              <button
                type="button"
                className="delete-confirm-close"
                onClick={closeDeleteFolderDialog}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <p className="delete-confirm-text">Are you sure want delete?</p>
            <div className="delete-confirm-actions">
              <button
                type="button"
                className="delete-btn secondary"
                onClick={closeDeleteFolderDialog}
              >
                No
              </button>
              <button
                type="button"
                className="delete-btn danger"
                onClick={confirmDeleteFolder}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete comment confirmation modal */}
      {deleteCommentDialog.open && (
        <Modal
          title={null}
          open={deleteCommentDialog.open}
          handleClose={closeDeleteCommentDialog}
          className="delete-confirm-modal timesheet-view-modal"
        >
          <div className="delete-confirm">
            <div className="delete-confirm-header">
              <h3>Delete</h3>
              <button
                type="button"
                className="delete-confirm-close"
                onClick={closeDeleteCommentDialog}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <p className="delete-confirm-text">Are you sure want delete?</p>
            <div className="delete-confirm-actions">
              <button
                type="button"
                className="delete-btn secondary"
                onClick={closeDeleteCommentDialog}
              >
                No
              </button>
              <button
                type="button"
                className="delete-btn danger"
                onClick={confirmDeleteComment}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete invoice confirmation modal */}
      {deleteInvoiceDialog.open && (
        <Modal
          title={null}
          open={deleteInvoiceDialog.open}
          handleClose={closeDeleteInvoiceDialog}
          className="delete-confirm-modal timesheet-view-modal"
        >
          <div className="delete-confirm">
            <div className="delete-confirm-header">
              <h3>Delete</h3>
              <button
                type="button"
                className="delete-confirm-close"
                onClick={closeDeleteInvoiceDialog}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <p className="delete-confirm-text">Are you sure want delete?</p>
            <div className="delete-confirm-actions">
              <button
                type="button"
                className="delete-btn secondary"
                onClick={closeDeleteInvoiceDialog}
              >
                No
              </button>
              <button
                type="button"
                className="delete-btn danger"
                onClick={confirmDeleteInvoice}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Payment Status Modal */}
      {paymentStatusModal && selectedInvoice && (
        <PaymentStatusModal
          open={paymentStatusModal}
          handleClose={handlePaymentStatusClose}
          invoice={{
            ...selectedInvoice,
            amount_due: Math.max(
              (parseFloat(selectedInvoice.total) || 0) -
                (parseFloat(selectedInvoice.amount_paid || 0) || 0),
              0,
            ).toFixed(2),
          }}
        />
      )}

      {/* Invoice Preview Modal */}
      {documentContent.state && (
        <Modal
          className="timesheet-view-modal"
          open={documentContent.state}
          maxWidth
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 style={{ fontWeight: "bold" }}>Invoice Preview</h2>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Button
                text="Print"
                variant="outline"
                icon={<PrintRounded />}
                handleClick={() => handlePrint()}
              />
              <button
                className="close-btn"
                onClick={() => setDocumentContent({ state: false, data: {} })}
              >
                ✕
              </button>
            </div>
          </div>
          <ContractInvoiceView
            id={false}
            data={documentContent.data}
            label="Invoice"
          />
        </Modal>
      )}

      {/* Print/Email Invoice View (hidden, for printing) */}
      {documentContent.data && Object.keys(documentContent.data).length > 0 && (
        <div style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
          <ContractInvoiceView
            inputRef={componentRef}
            id="divToPrint"
            data={documentContent.data}
            label="Invoice"
          />
        </div>
      )}

      <DocuSignSendModal
        open={signatureModal.open}
        onClose={() => setSignatureModal({ open: false, document: null })}
        document={signatureModal.document}
        clientId={id}
        documentCategory={categoryTab}
        defaultSigner={{
          name: `${clientData?.first_name || ""} ${clientData?.last_name || ""}`.trim(),
          email: clientData?.email || "",
        }}
        onSuccess={() => {
          setSignatureModal({ open: false, document: null });
          setSignatureRefreshKey((value) => value + 1);
          if (activeTab !== "documents") {
            setActiveTab("documents");
          }
          if (docFileType !== DOC_TAB_SENT_FOR_SIGNATURE) {
            handleDocFileTypeChange(DOC_TAB_SENT_FOR_SIGNATURE);
          }
        }}
      />
    </div>
  );
};

export default ClientDetails;
